<template>
    <v-container fluid :class="(user.role === 'Customer' ? 'pa-0' : '')">
        <!--v-expand-transition>
            <v-banner v-if="idValidator === true">
                <v-icon slot="icon" color="primary" size="36">mdi-card-account-details</v-icon>
                <span v-if="show === false">Completa tus Datos
                    <v-progress-linear v-model="idAdvance" color="primary" height="32" class="mt-2">
                        <strong :class="idAdvance > 49 ? 'white--text' : 'primary--text'">{{ Math.ceil(idAdvance) }}%</strong>
                    </v-progress-linear>
                </span>
                <v-skeleton-loader min-width="300px" type="list-item" v-else/>
                <template v-slot:actions="{ dismiss }">
                    <v-btn text color="success" to="/profile/edit" v-if="show === false">Completar</v-btn>
                    <v-skeleton-loader type="button" min-width="100px" style="" v-else/>
                    <v-btn text color="error" @click="dismiss" v-if="show === false">Cerrar</v-btn>
                    <v-skeleton-loader type="button" min-width="100px" style="" v-else/>
                </template>
            </v-banner>
        </v-expand-transition-->
        <v-row v-if="user.role === 'Customer'">
            <v-col cols="12" class="py-0">
                <v-skeleton-loader class="mx-auto" width="100%" type="article" v-if="loading === true"/>
                <v-card dark color="primary" tile elevation="0" class="wallet-hero" v-else>
                    <v-card-text class="wallet-hero-content pt-7 pb-10">
                        <div class="wallet-balance-carousel mx-auto mt-4">
                            <v-btn
                                icon
                                color="secondary"
                                class="wallet-balance-arrow d-none d-sm-inline-flex"
                                :disabled="balanceCards.length <= 1"
                                @click="previousWalletCard">
                                <v-icon large>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-window
                                v-model="selectedWalletCurrency"
                                :touch="walletCarouselTouch"
                                class="wallet-balance-window">
                                <v-window-item
                                    v-for="card in balanceCards"
                                    :key="card.currency"
                                    :value="card.currency">
                                    <div class="wallet-balance-main mx-auto text-center">
                                        <div class="subtitle-2 font-weight-medium secondary--text text-uppercase">Saldo disponible</div>
                                        <div class="text-h4 text-sm-h3 font-weight-bold white--text my-2">{{ card.formatted }}</div>
                                        <div class="mt-3" v-if="card.pendingNetworks.length && !card.hasActiveNetwork">
                                            <v-btn
                                                small
                                                depressed
                                                color="secondary"
                                                class="primary--text"
                                                :loading="cryptoActivatingKey === card.currency"
                                                :disabled="!!cryptoActivatingKey"
                                                @click.stop="activateCurrencyWallet(card)">
                                                <v-icon left small>mdi-plus-circle</v-icon>Activar
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-window-item>
                            </v-window>
                            <v-btn
                                icon
                                color="secondary"
                                class="wallet-balance-arrow d-none d-sm-inline-flex"
                                :disabled="balanceCards.length <= 1"
                                @click="nextWalletCard">
                                <v-icon large>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                        <div class="wallet-carousel-dots text-center mt-3" v-if="balanceCards.length > 1">
                            <v-btn
                                v-for="card in balanceCards"
                                :key="'wallet-dot-' + card.currency"
                                icon
                                x-small
                                color="secondary"
                                :class="{ 'wallet-carousel-dot-active': card.currency === selectedWalletCurrency }"
                                @click="selectedWalletCurrency = card.currency">
                                <v-icon x-small>mdi-circle</v-icon>
                            </v-btn>
                        </div>
                        <div class="wallet-hero-header d-flex flex-column align-center justify-center">
                            <div
                                v-if="dynamicKey.enabled && dynamicKey.code"
                                role="button"
                                title="Copiar clave dinámica"
                                class="wallet-dynamic-key px-3 py-2"
                                @click="copyDynamicKey(dynamicKey.code)">
                                <div class="d-flex align-center justify-center">
                                    <v-icon small color="secondary" class="mr-1">mdi-cellphone-lock</v-icon>
                                    <span class="body-2 secondary--text font-weight-bold mr-2 d-none d-sm-inline">Clave dinámica</span>
                                    <span class="subtitle-1 white--text font-weight-bold">{{ dynamicKey.code }}</span>
                                    <span class="body-2 secondary--text font-weight-bold ml-2">{{ dynamicKey.remaining }}s</span>
                                </div>
                                <v-progress-linear
                                    :value="dynamicKeyProgress"
                                    color="secondary"
                                    background-color="rgba(255, 255, 255, .18)"
                                    height="3"
                                    rounded
                                    class="mt-1"/>
                            </div>
                            <v-btn
                                depressed
                                fab
                                color="secondary"
                                class="wallet-hero-qr-btn"
                                @click="openReceiveQrDialog">
                                <v-icon large color="primary">mdi-qrcode-scan</v-icon>
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" class="pt-0">
                <v-card color="card" outlined class="px-2" style="margin-top: -20px; border-radius: 20px 20px 0 0">
                    <v-card-text>
                        <v-row justify="center">
                            <template v-for="item in actions">
                                <v-col cols="3" class="pa-1" :key="item.name">
                                    <v-skeleton-loader class="mx-auto" width="100%" type="image" v-if="loading === true"/>
                                    <v-card
                                        dark
                                        color="primary"
                                        height="84"
                                        class="px-1 py-2 text-center d-flex flex-column align-center justify-center rounded-lg"
                                        @click="openWallet(item.action)"
                                        v-else>
                                        <v-icon size="34">mdi-{{ item.icon }}</v-icon>
                                        <v-card-subtitle class="px-0 py-1 d-block caption font-weight-medium">{{ item.name }}</v-card-subtitle>
                                    </v-card>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" class="pt-0" v-if="incomingPaymentRequests.length">
                <v-card color="card" outlined class="mx-2 mb-3">
                    <v-card-title class="subtitle-1 font-weight-bold primary--text">
                        <v-icon color="primary" class="mr-2">mdi-cash-clock</v-icon>
                        Solicitudes por aprobar
                    </v-card-title>
                    <v-card-text class="pt-0">
                        <v-list two-line color="transparent" class="pa-0">
                            <template v-for="item in incomingPaymentRequests">
                                <v-list-item :key="'request-' + item.id" class="px-0">
                                    <v-list-item-avatar color="secondary" class="primary--text">
                                        <v-icon color="primary">mdi-cash-clock</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">
                                            {{ item.requester_name || item.requester_nickname }} solicita {{ item.amount }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="item.note">{{ item.note }}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{ item.date }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-row :key="'request-actions-' + item.id" dense class="mb-3">
                                    <v-col cols="6">
                                        <v-btn
                                            block
                                            small
                                            color="primary"
                                            class="secondary--text"
                                            :loading="paymentRequestLoadingId === 'approve-' + item.id"
                                            :disabled="!!paymentRequestLoadingId"
                                            @click="approvePaymentRequest(item)">
                                            <v-icon left small>mdi-check-circle</v-icon> Pagar ahora
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn
                                            block
                                            small
                                            outlined
                                            color="error"
                                            :loading="paymentRequestLoadingId === 'reject-' + item.id"
                                            :disabled="!!paymentRequestLoadingId"
                                            @click="rejectPaymentRequest(item)">
                                            <v-icon left small>mdi-close-circle</v-icon> Rechazar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!--v-row v-if="user.role === 'Customer'">
            <v-col cols="12">
                <v-skeleton-loader class="mx-auto" width="100%" type="list-item-avatar-three-line" v-if="loading === true"/>
                <v-card link to="/profile/edit" v-else>
                    <v-card-text class="py-1 py-sm-2">
                        <v-list class="pa-0" color="transparent">
                            <v-list-item class="pa-0" three-line>
                                <v-list-item-avatar class="my-0 align-self-center" size="64" style="border: 1px solid #ccc">
                                    <img :src="'/' + (user.photo ? user.photo : (user.role === 'Customer' ? 'img/photo-default.jpg' : 'img/soporte.jpg' ))" :alt="user.name">
                                </v-list-item-avatar>
                                <v-list-item-content class="pa-0 align-self-center">
                                    <v-list-item-title class="font-weight-bold mb-1 text-sm-h6 text-lg-h5">{{user.name}}</v-list-item-title>
                                    <v-list-item-content :class="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary'))) + '--text d-inline-block py-0 font-weight-bold mb-1'">
                                        {{ user.status === 103 ? 'Verificado' : (user.status === 102 ? 'En Revisión' : (user.status === 104 ? 'Bloqueado' : 'Sin Verificar'))  }}
                                        <v-icon small :color="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary')))">{{ 'mdi-'+(user.status === 103 ? 'check' : (user.status === 102 ? 'sync' : (user.status === 104 ? 'close' : 'alert'))) + '-circle' }}</v-icon>
                                    </v-list-item-content>
                                    <v-list-item-subtitle class="font-weight-bold mb-1">ID: {{ user.id === null ? '' : (user.id).toString().padStart(5, 0) }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-btn small depressed :color="(user.status === 103 ? 'success' : (user.status === 102 ? 'info' : (user.status === 104 ? 'error' : 'tertiary white--text')))" fab to="/profile/edit">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center" align-content="center" v-if="user.role === 'Customer'">
            <v-col cols="6" sm="4" md="2">
                <v-skeleton-loader class="mx-auto" width="100%" type="list-item-avatar-two-line" v-if="loading === true"/>
                <v-card class="px-3 text-center" @click="rate_view = true" v-else>
                    <v-icon class="pt-3" size="64">mdi-cash-multiple</v-icon>
                    <v-card-subtitle class="px-0 py-3 d-block">Tasa Actual</v-card-subtitle>
                </v-card>
            </v-col>
            <template v-for="item in actions">
                <v-col cols="6" sm="4" md="2">
                    <v-skeleton-loader class="mx-auto" width="100%" type="list-item-avatar-two-line" v-if="loading === true"/>
                    <v-card class="px-3 text-center" :to="item.link" v-else>
                        <v-icon class="pt-3" size="64">mdi-{{ item.icon }}</v-icon>
                        <v-card-subtitle class="px-0 py-3 d-block">{{ item.name }}</v-card-subtitle>
                    </v-card>
                </v-col>
            </template>
            <v-dialog v-model="rate_view" fullscreen v-if="rates">
                <v-card color="card">
                    <v-toolbar dark color="primary" class="px-2">
                        <v-btn icon large @click="rate_view = false" class="bg primary--text">
                            <v-icon>mdi-home</v-icon>
                        </v-btn>
                        <v-toolbar-title class="d-inline-block text-center font-weight-medium pl-0" style="white-space:normal;width:100%">TASA DE CAMBIO</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                        <v-btn icon large @click="rate_view = false" class="bg primary--text">
                            <v-icon>mdi-close-thick</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="px-0">
                        <v-container>
                            <v-row justify="center">
                                <template v-for="c in rate_countries" v-if="c.code !== user.country">
                                    <v-col cols="12" sm="6" md="4">
                                        <v-simple-table>
                                            <tbody>
                                            <tr class="bg">
                                                <th colspan="2" class="subtitle-1 font-weight-bold text-center">
                                                    <v-avatar size="26px">
                                                        <img :src="'/img/country/' + c.code + '.png'" :title="c.name" :alt="c.name.toLowerCase()"/>
                                                    </v-avatar>&nbsp;&nbsp;{{ c.name }}
                                                </th>
                                            </tr>
                                            <template v-for="i in rates" v-if="i.country_receiver === c.code && i.bank_receiver === c.bank">
                                                <tr v-if="i.currency_send === 'COP'">
                                                    <td class="text-right">{{ Number(i.type === 'sell' ? i.value : (1 / i.value)).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) }} {{ i.currency_send }}</td>
                                                    <td>1 {{ i.currency_receiver }}</td>
                                                </tr>
                                                <tr v-else>
                                                    <td class="text-right">1 {{ i.currency_send }}</td>
                                                    <td>{{ Number(i.type === 'sell' ? (1 / i.value) : i.value).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 6}) }} {{ i.currency_receiver }}</td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </v-simple-table>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-container grid-list-sm>
                        <v-row justify="center">
                            <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
                                <v-btn to="/about" color="primary" large style="display:inline-grid;white-space:normal;">Como depositar en nuestras cuentas</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row-->
        <v-row v-if="user.role === 'Customer'">
            <v-col cols="12">
                <v-skeleton-loader class="mx-auto" width="100%" type="list-item-two-line" v-if="loading === true"/>
                <v-card outlined class="wallet-activity-card mx-2" v-else>
                    <v-card-title class="subtitle-1 font-weight-bold primary--text">
                        <v-icon color="primary" class="mr-2">mdi-history</v-icon>
                        Ultimas transacciones
                        <v-spacer/>
                        <v-btn small text color="primary" to="/history">
                            <v-icon left small>mdi-list-status</v-icon>Ver todo
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text class="px-0 py-2">
                        <v-skeleton-loader class="mx-auto" width="100%" type="list-item-three-line" v-if="loading === true"/>
                        <div class="text-center py-8" v-if="transactions.length === 0">
                            <v-icon size="48" color="primary">mdi-history</v-icon>
                            <div class="subtitle-2 font-weight-bold mt-2">No tienes transacciones recientes</div>
                        </div>
                        <template v-for="item in transactions">
                            <v-list-item :key="item.type + '-' + item.id" class="wallet-activity-item" :to="item.route || undefined">
                                <v-list-item-avatar :color="item.direction === 'credit' ? 'success' : 'error'" class="white--text">
                                    <v-icon color="white">mdi-{{ item.icon }}</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="font-weight-bold d-flex align-center flex-wrap">
                                        <span class="mr-2">{{ item.title }}</span>
                                        <v-chip x-small label :color="transactionStatusColor(item)" dark>
                                            {{ item.status_name }}
                                        </v-chip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-truncate">{{ item.subtitle }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <v-icon x-small color="grey" class="mr-1">mdi-clock-outline</v-icon>{{ item.date }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action class="wallet-activity-action">
                                    <strong :class="(item.direction === 'credit' ? 'success' : 'error') + '--text'">
                                        {{ item.amount }}
                                    </strong>
                                    <v-icon small color="primary" v-if="item.route">mdi-chevron-right</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="'divider-' + item.type + '-' + item.id"/>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="walletDialog" fullscreen hide-overlay transition="dialog-bottom-transition" @input="walletDialogChanged">
            <v-card color="card" height="100%" class="wallet-fixed-dialog">
                <v-toolbar dark color="primary" class="wallet-fixed-header">
                    <v-btn icon color="secondary" @click="walletMode === 'scan' ? returnFromScanner() : closeWallet()">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-toolbar-title class="font-weight-bold">{{ walletTitle }}</v-toolbar-title>
                    <v-spacer/>
                    <v-chip small color="secondary" class="primary--text font-weight-bold" v-if="walletMode !== 'scan'">
                        {{ primaryBalance.formatted }}
                    </v-chip>
                </v-toolbar>

                <v-card-text :class="['wallet-fixed-body', 'pa-0', {'wallet-scan-body': walletMode === 'scan'}]">
                    <v-container
                        :fluid="walletMode === 'scan'"
                        :class="walletMode === 'scan' ? 'wallet-dialog-container wallet-scan-container pa-0' : 'wallet-dialog-container py-6 py-sm-8'">
                        <v-row justify="center">
                            <v-col
                                cols="12"
                                :sm="walletMode === 'scan' ? 12 : 10"
                                :md="walletMode === 'scan' ? 12 : 8"
                                :lg="walletMode === 'scan' ? 12 : 6"
                                :class="['wallet-dialog-col', {'wallet-scan-col': walletMode === 'scan'}]">
                                <section v-if="walletMode === 'recharge'">
                                    <v-form ref="rechargeForm" v-model="walletValid" @submit.prevent="submitRecharge">
                                        <v-stepper v-model="rechargeStep" flat class="wallet-recharge-stepper">
                                            <v-stepper-header>
                                                <v-stepper-step :complete="rechargeStep > 1" step="1">Monto</v-stepper-step>
                                                <v-divider/>
                                                <v-stepper-step :complete="rechargeStep > 2" step="2">Medio</v-stepper-step>
                                                <v-divider/>
                                                <v-stepper-step step="3">Comprobante</v-stepper-step>
                                            </v-stepper-header>
                                            <v-stepper-items>
                                                <v-stepper-content step="1" class="px-0">
                                                    <v-select
                                                        v-model="rechargeForm.currency"
                                                        :items="rechargeCurrencies"
                                                        :item-text="currencyLabel"
                                                        item-value="code"
                                                        label="Moneda de pago"
                                                        prepend-icon="mdi-currency-usd"
                                                        :rules="[walletRules.required]"
                                                        @change="onRechargeCurrencyChange"/>
                                                    <v-select
                                                        v-model="rechargeForm.target_currency"
                                                        :items="rechargeWalletCurrencies"
                                                        :item-text="currencyLabel"
                                                        item-value="code"
                                                        label="Moneda que recibes"
                                                        prepend-icon="mdi-wallet-plus"
                                                        :rules="[walletRules.required]"
                                                        @change="onQuoteControlChange('recharge')"/>
                                                    <v-currency-field
                                                        ref="rechargeAmountField"
                                                        v-model="rechargeForm.amount"
                                                        label="Monto a pagar"
                                                        prepend-icon="mdi-cash-plus"
                                                        :rules="rechargeRules"
                                                        v-bind="currencyFieldConfig(rechargeForm.currency)"
                                                        @input="onQuoteControlChange('recharge')"/>
                                                    <div class="body-2 text--secondary mb-2" v-if="rechargeLimitText">
                                                        {{ rechargeLimitText }}
                                                    </div>
                                                    <div class="body-2 warning--text font-weight-bold mb-2" v-if="quoteErrors.recharge">
                                                        {{ quoteErrors.recharge }}
                                                    </div>
                                                    <v-card outlined class="mb-4" v-if="rechargeQuote || quoteLoading.recharge">
                                                        <v-card-title class="subtitle-2 py-2">
                                                            Conversion a {{ rechargeWalletCurrency }}
                                                            <v-spacer/>
                                                            <v-chip small outlined color="primary" v-if="rechargeQuote && quoteMatches('recharge')">
                                                                <v-icon left small>mdi-timer-outline</v-icon>{{ quoteCountdownText('recharge') }}
                                                            </v-chip>
                                                        </v-card-title>
                                                        <v-divider/>
                                                        <v-list dense class="transparent">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>Pagas</v-list-item-title>
                                                                </v-list-item-content>
                                                                <v-list-item-action class="font-weight-bold">
                                                                    <v-skeleton-loader v-if="quoteLoading.recharge" type="text" width="130"/>
                                                                    <span v-else>{{ rechargeQuote ? rechargeQuote.source_amount_formatted : '--' }}</span>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>Tasa actual</v-list-item-title>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <v-skeleton-loader v-if="quoteLoading.recharge" type="text" width="160"/>
                                                                    <span v-else>{{ rechargeQuote ? rechargeQuote.rate_label : '--' }}</span>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>Comision de recarga</v-list-item-title>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <v-skeleton-loader v-if="quoteLoading.recharge" type="text" width="120"/>
                                                                    <span v-else>{{ feeText(rechargeQuote, 'source') }}</span>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>Comision de conversion</v-list-item-title>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <v-skeleton-loader v-if="quoteLoading.recharge" type="text" width="120"/>
                                                                    <span v-else>{{ feeText(rechargeQuote, 'target') }}</span>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                            <v-divider/>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-weight-bold">Recibes</v-list-item-title>
                                                                </v-list-item-content>
                                                                <v-list-item-action class="success--text font-weight-bold">
                                                                    <v-skeleton-loader v-if="quoteLoading.recharge" type="text" width="130"/>
                                                                    <span v-else>{{ rechargeQuote ? rechargeQuote.target_amount_formatted : '--' }}</span>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card>
                                                    <v-btn block large color="primary" :disabled="!rechargeAmountReady" @click="goRechargeStep(2)">
                                                        Continuar
                                                    </v-btn>
                                                </v-stepper-content>
                                                <v-stepper-content step="2" class="px-0">
                                                    <v-select
                                                        v-model="rechargeForm.payment_account_id"
                                                        :items="rechargePaymentAccounts"
                                                        item-text="label"
                                                        item-value="id"
                                                        label="Medio de pago"
                                                        prepend-icon="mdi-bank-transfer-in"
                                                        :rules="[walletRules.required]"
                                                        :disabled="rechargePaymentAccounts.length === 0"/>
                                                    <div class="body-2 warning--text font-weight-bold mb-3" v-if="rechargePaymentAccounts.length === 0">
                                                        No hay medios activos para recibir {{ rechargeForm.currency }} en este momento.
                                                    </div>
                                                    <v-card outlined class="mb-4" v-if="selectedRechargePaymentAccount">
                                                        <v-list dense class="transparent">
                                                            <v-list-item v-if="selectedRechargePaymentAccount.gateway">
                                                                <v-list-item-avatar v-if="selectedRechargePaymentAccount.gateway.img" tile size="42">
                                                                    <img :src="selectedRechargePaymentAccount.gateway.img" :alt="selectedRechargePaymentAccount.gateway.name">
                                                                </v-list-item-avatar>
                                                                <v-list-item-icon v-else>
                                                                    <v-icon color="primary">mdi-credit-card-check</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>{{ selectedRechargePaymentAccount.gateway.name }}</v-list-item-title>
                                                                    <v-list-item-subtitle>Medio seleccionado</v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-bank</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>{{ selectedRechargePaymentAccount.bank_name }}</v-list-item-title>
                                                                    <v-list-item-subtitle>{{ selectedRechargePaymentAccount.currency }}</v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-credit-card-outline</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-break">{{ selectedRechargePaymentAccount.code }}</v-list-item-title>
                                                                    <v-list-item-subtitle>Dato para pagar</v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <v-btn
                                                                        icon
                                                                        color="primary"
                                                                        v-clipboard:copy="selectedRechargePaymentAccount.code"
                                                                        v-clipboard:success="onCopy"
                                                                        v-clipboard:error="onError">
                                                                        <v-icon>mdi-content-copy</v-icon>
                                                                    </v-btn>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                        </v-list>
                                                        <v-sheet
                                                            v-if="selectedRechargePaymentAccount.instructions"
                                                            outlined
                                                            rounded
                                                            class="wallet-payment-instructions pa-3 mx-3 mb-3">
                                                            <div class="caption text-uppercase font-weight-bold primary--text mb-2">Como pagar</div>
                                                            <div class="body-2" v-html="selectedRechargePaymentAccount.instructions"/>
                                                        </v-sheet>
                                                    </v-card>
                                                    <v-row dense>
                                                        <v-col cols="5">
                                                            <v-btn block large text color="primary" @click="goRechargeStep(1)">Atras</v-btn>
                                                        </v-col>
                                                        <v-col cols="7">
                                                            <v-btn block large color="primary" :disabled="!rechargePaymentReady" @click="goRechargeStep(3)">Continuar</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-content>
                                                <v-stepper-content step="3" class="px-0">
                                                    <v-file-input
                                                        v-model="rechargeForm.voucher"
                                                        label="Comprobante"
                                                        accept="image/png,image/jpeg,application/pdf"
                                                        prepend-icon="mdi-paperclip"
                                                        :rules="[walletRules.required]"/>
                                                    <v-row dense>
                                                        <v-col cols="5">
                                                            <v-btn block large text color="primary" @click="goRechargeStep(2)">Atras</v-btn>
                                                        </v-col>
                                                        <v-col cols="7">
                                                            <v-btn block large color="primary" :loading="walletLoading" :disabled="walletLoading || !walletValid || !canSubmitQuote('recharge') || !rechargeDestinationReady" @click="submitRecharge">
                                                                <v-icon left>mdi-upload</v-icon> Enviar
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-content>
                                            </v-stepper-items>
                                        </v-stepper>
                                    </v-form>
                                </section>

                                <section v-else-if="walletMode === 'receive'" class="text-center">
                                    <v-sheet color="secondary" rounded class="receive-qr-card mx-auto pa-5 text-center" light>
                                        <h2 class="primary--text font-weight-bold mb-1">Escanea y paga</h2>
                                        <div class="body-2 grey--text text--darken-1 mb-4">Paga directo con Valzum</div>
                                        <div class="receive-qr-box mx-auto">
                                            <vue-qrcode :value="qrValue" :scale="9" :margin="1" :version="3"/>
                                            <img class="valzum-qr-center-logo" src="/img/favicon.png" alt="Valzum">
                                        </div>
                                        <div class="text-h5 primary--text font-weight-bold mt-4">{{ accountTag }}</div>
                                    </v-sheet>
                                    <v-row dense class="mt-5">
                                        <v-col cols="12" sm="6">
                                            <v-btn
                                                block
                                                large
                                                color="primary"
                                                v-clipboard:copy="qrValue"
                                                v-clipboard:success="onCopy"
                                                v-clipboard:error="onError">
                                                <v-icon left>mdi-content-copy</v-icon> Copiar nickname
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-btn block large outlined color="primary" @click="downloadReceiveQr">
                                                <v-icon left>mdi-download</v-icon> Descargar QR
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <template v-if="crypto.enabled && cryptoAssetItems.length">
                                        <v-divider class="my-4"/>
                                        <div class="crypto-asset-picker text-left mb-3">
                                            <div class="caption text-uppercase font-weight-bold primary--text mb-2">Moneda</div>
                                            <v-chip-group
                                                v-model="cryptoReceiveCurrency"
                                                mandatory
                                                column
                                                active-class="crypto-asset-chip-active"
                                                @change="onCryptoReceiveCurrencyChange">
                                                <v-chip
                                                    v-for="item in cryptoReceiveCurrencyItems"
                                                    :key="'wallet-receive-currency-' + item.asset"
                                                    :value="item.asset"
                                                    label
                                                    outlined
                                                    class="crypto-asset-chip mr-2 mb-2">
                                                    <span class="crypto-asset-symbol mr-2">{{ cryptoAssetSymbol(item.asset, item) }}</span>
                                                    <span class="font-weight-bold">{{ item.asset }}</span>
                                                </v-chip>
                                            </v-chip-group>
                                            <template v-if="cryptoReceiveNetworkItems.length">
                                                <div class="caption text-uppercase font-weight-bold primary--text mt-2 mb-2">Red</div>
                                                <v-chip-group
                                                    v-model="cryptoReceiveAssetKey"
                                                    mandatory
                                                    column
                                                    active-class="crypto-asset-chip-active"
                                                    @change="onCryptoReceiveNetworkChange">
                                                    <v-chip
                                                        v-for="item in cryptoReceiveNetworkItems"
                                                        :key="'wallet-receive-network-' + item.value"
                                                        :value="item.value"
                                                        label
                                                        outlined
                                                        class="crypto-asset-chip mr-2 mb-2">
                                                        {{ item.network_label }}
                                                    </v-chip>
                                                </v-chip-group>
                                            </template>
                                        </div>
                                        <v-btn v-if="!selectedCryptoAddress" block outlined color="primary" :loading="cryptoAddressLoading" :disabled="cryptoAddressLoading || !cryptoReceiveAssetKey" @click="loadCryptoAddress">
                                            <v-icon left>mdi-wallet-plus</v-icon> Generar direccion
                                        </v-btn>
                                        <v-card outlined class="mt-3" v-if="cryptoAddressLoading || selectedCryptoAddress">
                                            <v-card-text class="text-center">
                                                <v-skeleton-loader v-if="cryptoAddressLoading" type="image, list-item-two-line"/>
                                                <template v-else-if="selectedCryptoAddress">
                                                    <div class="receive-crypto-qr-card mx-auto pa-3">
                                                        <div class="text-h6 primary--text font-weight-bold mb-2">
                                                            {{ selectedCryptoAddress.asset }} · {{ selectedCryptoAddress.network_label }}
                                                        </div>
                                                        <div class="receive-qr-box receive-crypto-qr-box mx-auto">
                                                            <vue-qrcode :value="selectedCryptoAddress.qr_value" :scale="7" :margin="1" :version="4"/>
                                                            <div class="crypto-qr-center-badge">
                                                                <img
                                                                    v-if="cryptoAssetLogo(selectedCryptoAddress.asset, selectedCryptoAddress)"
                                                                    :src="cryptoAssetLogo(selectedCryptoAddress.asset, selectedCryptoAddress)"
                                                                    :alt="selectedCryptoAddress.asset"
                                                                    class="crypto-qr-center-logo">
                                                                <span v-else>{{ cryptoAssetSymbol(selectedCryptoAddress.asset, selectedCryptoAddress) }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="caption font-weight-bold primary--text mt-2">Direccion</div>
                                                        <div class="caption text-break mt-1">{{ selectedCryptoAddress.address }}</div>
                                                        <div class="caption" v-if="selectedCryptoAddress.tag">Tag/Memo: {{ selectedCryptoAddress.tag }}</div>
                                                    </div>
                                                </template>
                                            </v-card-text>
                                            <v-card-actions v-if="selectedCryptoAddress">
                                                <v-row dense>
                                                    <v-col cols="12" sm="6">
                                                        <v-btn
                                                            block
                                                            text
                                                            color="primary"
                                                            v-clipboard:copy="selectedCryptoAddress.address"
                                                            v-clipboard:success="onCopy"
                                                            v-clipboard:error="onError">
                                                            <v-icon left>mdi-content-copy</v-icon> Copiar direccion
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-btn block text color="primary" @click="downloadCryptoQr">
                                                            <v-icon left>mdi-download</v-icon> Descargar QR
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                </section>

                                <section v-else-if="walletMode === 'request'">
                                    <v-alert dense text type="info">
                                        Solicita un pago a otro cliente Valzum. Le avisaremos para que revise el monto y autorice el pago desde su wallet.
                                    </v-alert>
                                    <v-form ref="requestPaymentForm" v-model="walletValid" @submit.prevent="submitPaymentRequest">
                                        <v-autocomplete
                                            v-if="walletContactItems.length"
                                            v-model="selectedRequestWalletContactNickname"
                                            :items="walletContactItems"
                                            item-text="text"
                                            item-value="value"
                                            label="Favoritos wallet"
                                            prepend-icon="mdi-star"
                                            clearable
                                            @change="selectRequestWalletContact"/>
                                        <v-text-field
                                            v-model="requestForm.nickname"
                                            label="Cliente que debe aprobar el pago"
                                            prefix="$"
                                            prepend-icon="mdi-account-cash"
                                            :loading="requestRecipientLoading"
                                            :rules="[walletRules.required]"
                                            @blur="lookupRequestRecipient"/>
                                        <v-alert dense text type="success" v-if="requestRecipient">
                                            {{ requestRecipient.name }} - {{ requestRecipient.nickname }}
                                        </v-alert>
                                        <v-select
                                            v-model="requestForm.currency"
                                            :items="requestCurrencies"
                                            :item-text="currencyLabel"
                                            item-value="code"
                                            label="Moneda"
                                            prepend-icon="mdi-currency-usd"
                                            :rules="[walletRules.required]"
                                            @change="refreshRequestAmountValidation"/>
                                        <v-currency-field
                                            ref="requestAmountField"
                                            v-model="requestForm.amount"
                                            label="Monto a solicitar"
                                            prepend-icon="mdi-cash-fast"
                                            v-bind="currencyFieldConfig(requestForm.currency)"
                                            :rules="requestRules"
                                            @input="refreshRequestAmountValidation"/>
                                        <v-alert dense text type="info" v-if="requestLimitText">
                                            {{ requestLimitText }}
                                        </v-alert>
                                        <v-textarea
                                            v-model="requestForm.note"
                                            label="Mensaje para quien va a pagar"
                                            rows="2"
                                            prepend-icon="mdi-note-text"/>
                                    </v-form>
                                    <v-btn block large color="primary" :loading="walletLoading" :disabled="walletLoading || !walletValid" @click="submitPaymentRequest">
                                        <v-icon left>mdi-cash-clock</v-icon> Enviar solicitud
                                    </v-btn>
                                </section>

                                <section v-else-if="walletMode === 'transfer'">
                                    <v-row dense class="wallet-transfer-actions mb-4">
                                        <v-col cols="6">
                                            <v-btn
                                                block
                                                depressed
                                                height="64"
                                                class="wallet-action-button"
                                                :color="payDestination === 'valzum' ? 'primary' : undefined"
                                                :outlined="payDestination !== 'valzum'"
                                                @click="setPayDestination('valzum')">
                                                <v-icon left>mdi-account-arrow-right</v-icon>
                                                <span>Valzum</span>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn
                                                block
                                                depressed
                                                height="64"
                                                class="wallet-action-button"
                                                :color="payDestination === 'crypto' ? 'primary' : undefined"
                                                :outlined="payDestination !== 'crypto'"
                                                :disabled="!cryptoSendOptionVisible"
                                                @click="setPayDestination('crypto')">
                                                <v-icon left>mdi-link-variant</v-icon>
                                                <span>Cripto</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <v-card outlined class="mb-4 wallet-pay-card" v-if="payDestination === 'valzum'">
                                        <v-card-text class="wallet-pay-card-body">
                                            <div class="wallet-pay-card-heading">
                                                <div class="subtitle-1 font-weight-bold primary--text">Pagar a cliente Valzum</div>
                                                <div class="body-2 text--secondary mt-1">Usa el $nickname, un favorito o el QR de Valzum.</div>
                                            </div>
                                            <v-btn block outlined color="primary" class="mb-4" @click="openWallet('scan')">
                                                <v-icon left>mdi-qrcode-scan</v-icon> Escanear QR Valzum
                                            </v-btn>
                                            <v-form ref="payForm" v-model="walletValid" @submit.prevent="submitPay">
                                                <v-autocomplete
                                                    v-if="walletContactItems.length"
                                                    v-model="selectedWalletContactNickname"
                                                    :items="walletContactItems"
                                                    item-text="text"
                                                    item-value="value"
                                                    label="Elegir favorito"
                                                    prepend-icon="mdi-star"
                                                    clearable
                                                    @change="selectWalletContact"/>
                                                <v-text-field
                                                    ref="payNicknameField"
                                                    v-model="payForm.nickname"
                                                    label="Nickname del cliente"
                                                    prefix="$"
                                                    prepend-icon="mdi-account-cash"
                                                    :loading="recipientLoading"
                                                    :rules="[walletRules.required]"
                                                    @blur="lookupRecipient"/>
                                                <v-alert dense text type="success" v-if="recipient">
                                                    <div class="d-sm-flex align-center justify-space-between">
                                                        <span>{{ recipient.name }} - {{ recipient.nickname }}</span>
                                                        <v-btn
                                                            v-if="!recipientIsWalletContact"
                                                            x-small
                                                            text
                                                            type="button"
                                                            color="primary"
                                                            :loading="contactSaving"
                                                            @click="saveRecipientContact">
                                                            <v-icon left small>mdi-star-plus</v-icon> Favorito
                                                        </v-btn>
                                                        <v-chip v-else x-small color="warning" text-color="white">
                                                            <v-icon left small>mdi-star</v-icon> Favorito
                                                        </v-chip>
                                                    </div>
                                                </v-alert>
                                                <v-checkbox
                                                    v-if="recipient && !recipientIsWalletContact"
                                                    v-model="payForm.save_contact"
                                                    dense
                                                    hide-details
                                                    class="mt-n2 mb-2"
                                                    label="Guardar como favorito al pagar"/>
                                                <v-select
                                                    v-model="payForm.currency"
                                                    :items="payCurrencies"
                                                    :item-text="currencyLabel"
                                                    item-value="code"
                                                    label="Saldo a usar"
                                                    prepend-icon="mdi-wallet"
                                                    :rules="[walletRules.required]"
                                                    @change="refreshPayAmountValidation"/>
                                                <v-currency-field
                                                    ref="payAmountField"
                                                    v-model="payForm.amount"
                                                    label="Monto a pagar"
                                                    prepend-icon="mdi-cash-fast"
                                                    v-bind="currencyFieldConfig(payForm.currency)"
                                                    :rules="payRules"
                                                    @input="refreshPayAmountValidation"/>
                                                <v-alert dense text type="info" v-if="payLimitText">
                                                    {{ payLimitText }}
                                                </v-alert>
                                                <v-textarea
                                                    v-model="payForm.note"
                                                    label="Mensaje opcional"
                                                    rows="2"
                                                    prepend-icon="mdi-note-text"/>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <v-btn
                                        v-if="payDestination === 'valzum'"
                                        block
                                        large
                                        color="primary"
                                        :loading="walletLoading"
                                        :disabled="walletLoading || !walletValid"
                                        @click="submitPay">
                                        <v-icon left>mdi-send</v-icon> Pagar a cliente Valzum
                                    </v-btn>

                                    <v-card outlined class="mb-4 wallet-pay-card" v-if="payDestination === 'crypto'">
                                        <v-card-text class="wallet-pay-card-body">
                                            <div class="wallet-pay-card-heading">
                                                <div class="subtitle-1 font-weight-bold primary--text">Pagar a billetera cripto</div>
                                                <div class="body-2 text--secondary mt-1">Selecciona moneda, red y direccion de destino.</div>
                                            </div>
                                            <v-alert dense text type="warning" v-if="!canSendCryptoExternally">
                                                {{ cryptoSendUnavailableReason }}
                                            </v-alert>
                                            <v-form
                                                v-else
                                                ref="cryptoPayForm"
                                                v-model="walletValid"
                                                @submit.prevent="submitCryptoWithdrawal">
                                                <div class="crypto-asset-picker mb-4">
                                                    <div class="caption text-uppercase font-weight-bold primary--text mb-2">Moneda</div>
                                                    <v-chip-group
                                                        v-model="cryptoPayCurrency"
                                                        mandatory
                                                        column
                                                        active-class="crypto-asset-chip-active"
                                                        @change="onCryptoPayCurrencyChange">
                                                        <v-chip
                                                            v-for="item in cryptoPayCurrencyItems"
                                                            :key="'wallet-pay-crypto-currency-' + item.asset"
                                                            :value="item.asset"
                                                            label
                                                            outlined
                                                            class="crypto-asset-chip mr-2 mb-2">
                                                            <span class="crypto-asset-symbol mr-2">{{ cryptoAssetSymbol(item.asset, item) }}</span>
                                                            <span class="font-weight-bold">{{ item.asset }}</span>
                                                        </v-chip>
                                                    </v-chip-group>
                                                    <template v-if="cryptoPayNetworkItems.length">
                                                        <div class="caption text-uppercase font-weight-bold primary--text mt-2 mb-2">Red</div>
                                                        <v-chip-group
                                                            v-model="cryptoWithdrawalForm.asset_key"
                                                            mandatory
                                                            column
                                                            active-class="crypto-asset-chip-active"
                                                            @change="onCryptoPayNetworkChange">
                                                            <v-chip
                                                                v-for="item in cryptoPayNetworkItems"
                                                                :key="'wallet-pay-crypto-network-' + item.value"
                                                                :value="item.value"
                                                                label
                                                                outlined
                                                                class="crypto-asset-chip mr-2 mb-2">
                                                                {{ item.network_label }}
                                                            </v-chip>
                                                        </v-chip-group>
                                                    </template>
                                                </div>
                                                <v-currency-field
                                                    v-model="cryptoWithdrawalForm.amount"
                                                    label="Monto a pagar"
                                                    prepend-icon="mdi-cash-fast"
                                                    v-bind="currencyFieldConfig(cryptoWithdrawalCurrency)"
                                                    :rules="cryptoWithdrawalRules"/>
                                                <v-sheet outlined rounded class="pa-3 mb-4" v-if="cryptoWithdrawalPreviewLoading">
                                                    <v-skeleton-loader type="list-item-two-line"/>
                                                    <v-skeleton-loader type="list-item-two-line"/>
                                                </v-sheet>
                                                <v-sheet outlined rounded class="pa-3 mb-4" v-if="cryptoWithdrawalFeePreview">
                                                    <v-list dense class="transparent pa-0">
                                                        <v-list-item class="px-0">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Monto</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action-text>{{ cryptoWithdrawalFeePreview.amount }}</v-list-item-action-text>
                                                        </v-list-item>
                                                        <v-list-item class="px-0" v-if="cryptoWithdrawalFeePreview.raw_valzum_fee > 0">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Comision Valzum</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action-text>{{ cryptoWithdrawalFeePreview.valzum_fee }}</v-list-item-action-text>
                                                        </v-list-item>
                                                        <v-list-item class="px-0" v-if="cryptoWithdrawalFeePreview.raw_network_fee > 0">
                                                            <v-list-item-content>
                                                                <v-list-item-title>Comision de red</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action-text>{{ cryptoWithdrawalFeePreview.network_fee }}</v-list-item-action-text>
                                                        </v-list-item>
                                                        <v-divider class="my-1" v-if="cryptoWithdrawalFeePreview.raw_total_fee > 0"/>
                                                        <v-list-item class="px-0">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-weight-bold">Total descontado</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action-text class="font-weight-bold primary--text">{{ cryptoWithdrawalFeePreview.total }}</v-list-item-action-text>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-sheet>
                                                <v-text-field
                                                    v-model="cryptoWithdrawalForm.destination_address"
                                                    label="Direccion de destino"
                                                    prepend-icon="mdi-wallet-outline"
                                                    :rules="[walletRules.required]"/>
                                                <v-text-field
                                                    v-model="cryptoWithdrawalForm.destination_tag"
                                                    label="Tag/Memo si aplica"
                                                    prepend-icon="mdi-tag-outline"/>
                                                <v-textarea
                                                    v-model="cryptoWithdrawalForm.note"
                                                    label="Mensaje opcional"
                                                    rows="2"
                                                    prepend-icon="mdi-note-text"/>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                    <v-btn
                                        v-if="payDestination === 'crypto'"
                                        block
                                        large
                                        color="primary"
                                        :loading="walletLoading"
                                        :disabled="walletLoading || !walletValid || !canSendCryptoExternally || !cryptoWithdrawalReady"
                                        @click="submitCryptoWithdrawal">
                                        <v-icon left>mdi-link-variant</v-icon> Pagar a billetera cripto
                                    </v-btn>
                                </section>

                                <section v-else-if="walletMode === 'scan'" class="wallet-scan-section">
                                    <v-alert dense text type="error" class="wallet-scan-alert" v-if="scanError">
                                        {{ scanError }}
                                    </v-alert>
                                    <div class="wallet-scanner">
                                        <qrcode-stream
                                            v-if="scanCamera !== 'off'"
                                            ref="walletQrStream"
                                            :key="'wallet-scan-stream-' + scanStreamKey"
                                            :camera="scanCamera"
                                            @decode="onQrDecode"
                                            @init="onQrInit">
                                            <div class="scan-overlay">
                                                <div class="scan-frame"></div>
                                                <div class="scan-caption">Alinea el QR de Valzum dentro del cuadro</div>
                                            </div>
                                        </qrcode-stream>
                                        <div class="wallet-scanner d-flex align-center justify-center" v-else>
                                            <div class="text-center px-4">
                                                <v-progress-circular
                                                    v-if="scanPermissionLoading"
                                                    indeterminate
                                                    color="primary"
                                                    size="54"/>
                                                <v-icon v-else size="72" color="primary">mdi-camera-off</v-icon>
                                                <div class="mt-3 font-weight-medium">
                                                    {{ scanPermissionLoading ? 'Solicitando permiso de camara' : 'Camara desactivada' }}
                                                </div>
                                                <v-btn
                                                    v-if="!scanPermissionLoading"
                                                    class="mt-3"
                                                    color="primary"
                                                    outlined
                                                    @click="startScanner">
                                                    <v-icon left>mdi-camera</v-icon> Activar camara
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wallet-scan-panel">
                                        <div class="wallet-scan-tools mb-3" v-if="scanCameraControlsVisible">
                                            <v-slider
                                                v-if="scanZoomSupported"
                                                v-model="scanZoom"
                                                :min="scanZoomBounds.min"
                                                :max="scanZoomBounds.max"
                                                :step="scanZoomBounds.step"
                                                dense
                                                hide-details
                                                color="primary"
                                                prepend-icon="mdi-magnify-plus-outline"
                                                @change="applyScannerZoom"/>
                                            <v-tooltip bottom v-if="scanFocusSupported">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="applyScannerFocus">
                                                        <v-icon>mdi-focus-field</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Enfocar</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="scanCameraDevices.length > 1">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="cycleScannerCamera">
                                                        <v-icon>mdi-camera-switch</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cambiar lente</span>
                                            </v-tooltip>
                                        </div>
                                        <v-text-field
                                            v-model="payForm.nickname"
                                            dense
                                            outlined
                                            hide-details="auto"
                                            label="Nickname detectado"
                                            prefix="$"
                                            prepend-icon="mdi-account-cash"
                                            @blur="lookupRecipient"/>
                                        <v-alert dense text type="success" class="mt-2 mb-0" v-if="recipient">
                                            {{ recipient.name }} - {{ recipient.nickname }}
                                        </v-alert>
                                        <v-btn block large color="primary" class="mt-3" :disabled="!payForm.nickname" @click="continueScannedPayment">
                                            <v-icon left>mdi-arrow-right-circle</v-icon> Continuar pago
                                        </v-btn>
                                    </div>
                                </section>

                                <section v-else-if="walletMode === 'withdraw'">
                                    <v-form ref="withdrawForm" v-model="walletValid" @submit.prevent="submitWithdrawal">
                                        <v-select
                                            v-model="withdrawForm.source_currency"
                                            :items="withdrawSourceCurrencies"
                                            :item-text="currencyLabel"
                                            item-value="code"
                                            label="Saldo a usar"
                                            prepend-icon="mdi-wallet"
                                            :rules="[walletRules.required]"
                                            @change="onQuoteControlChange('withdrawal')"/>
                                        <v-select
                                            v-model="withdrawForm.currency"
                                            :items="withdrawCurrencies"
                                            :item-text="currencyLabel"
                                            item-value="code"
                                            label="Moneda a recibir"
                                            prepend-icon="mdi-currency-usd"
                                            :rules="[walletRules.required]"
                                            @change="onQuoteControlChange('withdrawal')"/>
                                        <v-currency-field
                                            ref="withdrawAmountField"
                                            v-model="withdrawForm.amount"
                                            :label="'Monto a retirar del wallet (' + withdrawSourceCurrency + ')'"
                                            prepend-icon="mdi-bank-transfer-out"
                                            :rules="withdrawRules"
                                            v-bind="currencyFieldConfig(withdrawSourceCurrency)"
                                            @input="onQuoteControlChange('withdrawal')"/>
                                        <v-alert dense text type="info" v-if="withdrawLimitText">
                                            {{ withdrawLimitText }}
                                        </v-alert>
                                        <v-select
                                            v-model="withdrawForm.payout_method"
                                            :items="withdrawalMethods"
                                            item-text="text"
                                            item-value="value"
                                            label="Forma de retiro"
                                            prepend-icon="mdi-storefront"
                                            :rules="[walletRules.required]"/>
                                        <template v-if="withdrawForm.payout_method === 'office'">
                                            <v-select
                                                v-model="withdrawForm.agent_office_id"
                                                :items="agentsWithDistance"
                                                item-text="display"
                                                item-value="id"
                                                label="Corresponsal/Agente"
                                                prepend-icon="mdi-store-marker"
                                                :rules="[walletRules.required]"/>
                                            <v-sheet outlined rounded class="pa-3 mb-4" v-if="selectedAgent">
                                                <v-list dense class="transparent pa-0">
                                                    <v-list-item class="px-0">
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-weight-bold">{{ selectedAgent.name }}</v-list-item-title>
                                                            <v-list-item-subtitle>{{ selectedAgent.address }}, {{ selectedAgent.city }}</v-list-item-subtitle>
                                                            <v-list-item-subtitle v-if="selectedAgent.opening_hours">{{ selectedAgent.opening_hours }}</v-list-item-subtitle>
                                                            <v-list-item-subtitle v-if="selectedAgent.distance !== null">
                                                                {{ formatDistance(selectedAgent.distance) }} de tu ubicacion
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                                <iframe
                                                    v-if="agentMapUrl(selectedAgent)"
                                                    :src="agentMapUrl(selectedAgent)"
                                                    width="100%"
                                                    height="220"
                                                    style="border:0"
                                                    loading="lazy"></iframe>
                                                <v-btn block outlined color="primary" class="mt-2" :href="agentMapLink(selectedAgent)" target="_blank">
                                                    <v-icon left>mdi-map-marker-radius</v-icon> Abrir mapa
                                                </v-btn>
                                            </v-sheet>
                                        </template>
                                        <template v-if="withdrawForm.payout_method === 'bank'">
                                            <v-sheet outlined rounded class="pa-3 mb-4">
                                                <div class="d-flex align-center">
                                                    <v-avatar color="primary" size="42" class="mr-3">
                                                        <v-icon color="secondary">mdi-bank-transfer-out</v-icon>
                                                    </v-avatar>
                                                    <div>
                                                        <div class="subtitle-2 font-weight-bold">Transferencia/Deposito</div>
                                                        <div class="caption">Solo a cuentas bancarias propias aprobadas.</div>
                                                    </div>
                                                </div>
                                            </v-sheet>
                                            <v-alert dense text type="info" v-if="bankAccounts.length === 0">
                                                No tienes cuentas bancarias aprobadas.
                                                <v-btn x-small text color="primary" to="/user/accounts">Registrar cuenta</v-btn>
                                            </v-alert>
                                            <v-select
                                                v-else
                                                v-model="withdrawForm.customer_bank_account_id"
                                                :items="bankAccounts"
                                                item-text="label"
                                                item-value="id"
                                                label="Cuenta bancaria propia"
                                                prepend-icon="mdi-bank-check"
                                                :rules="[walletRules.required]"/>
                                        </template>
                                        <v-alert dense text type="warning" v-if="quoteErrors.withdrawal">
                                            {{ quoteErrors.withdrawal }}
                                        </v-alert>
                                        <v-card outlined class="mb-4" v-if="withdrawQuote || quoteLoading.withdrawal">
                                            <v-card-title class="subtitle-2 py-2">
                                                Conversion de retiro
                                                <v-spacer/>
                                                <v-chip small outlined color="primary" v-if="withdrawQuote && quoteMatches('withdrawal')">
                                                    <v-icon left small>mdi-timer-outline</v-icon>{{ quoteCountdownText('withdrawal') }}
                                                </v-chip>
                                            </v-card-title>
                                            <v-divider/>
                                            <v-list dense class="transparent">
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Debitas del wallet</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action class="font-weight-bold">
                                                        <v-skeleton-loader v-if="quoteLoading.withdrawal" type="text" width="130"/>
                                                        <span v-else>{{ withdrawQuote ? withdrawQuote.source_amount_formatted : '--' }}</span>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Tasa actual</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-skeleton-loader v-if="quoteLoading.withdrawal" type="text" width="160"/>
                                                        <span v-else>{{ withdrawQuote ? withdrawQuote.rate_label : '--' }}</span>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Comision wallet</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-skeleton-loader v-if="quoteLoading.withdrawal" type="text" width="120"/>
                                                        <span v-else>{{ feeText(withdrawQuote, 'source') }}</span>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Comision de entrega</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-skeleton-loader v-if="quoteLoading.withdrawal" type="text" width="120"/>
                                                        <span v-else>{{ feeText(withdrawQuote, 'target') }}</span>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                <v-divider/>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Recibes aprox.</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action class="success--text font-weight-bold">
                                                        <v-skeleton-loader v-if="quoteLoading.withdrawal" type="text" width="130"/>
                                                        <span v-else>{{ withdrawQuote ? withdrawQuote.target_amount_formatted : '--' }}</span>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                        <v-textarea
                                            v-model="withdrawForm.note"
                                            label="Nota para transferencia/deposito"
                                            rows="2"
                                            prepend-icon="mdi-note-text"/>
                                    </v-form>
                                    <v-btn block large color="primary" :loading="walletLoading" :disabled="walletLoading || !walletValid || !canSubmitQuote('withdrawal') || !withdrawalDestinationReady()" @click="submitWithdrawal">
                                        <v-icon left>mdi-bank-transfer-out</v-icon> Solicitar retiro
                                    </v-btn>
                                </section>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row justify="center" v-if="user.role === 'Administrator'">
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'VPending' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="82">mdi-bank-transfer-in</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nPayments).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Verificación Pendiente</v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'TPending' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="82">mdi-bank-transfer-out</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nTransfers).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Transferencias Pendientes</v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'General' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="82">mdi-bank-transfer</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nComplete).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Transferencias Completadas</v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'CPending' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="70">mdi-face-agent</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nTickets).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Reclamos Pendientes</v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'Customers' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="70">mdi-account-multiple</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nUsers).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Clientes</v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2">
                <v-card outlined :to="{ name: 'CustomersOnline' }">
                    <div class="d-flex flex-no-wrap align-center justify-space-between">
                        <v-avatar class="ml-4" size="82" tile>
                            <v-icon size="70">mdi-account-clock</v-icon>
                        </v-avatar>
                        <v-card-text>
                            <div class="text-h3 text-right">{{ (nOnlineCustomers).toLocaleString("en-US") }}</div>
                        </v-card-text>
                    </div>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-subtitle class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">Clientes en linea</v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
        <v-divider class="mx-2 mx-sm-4 my-sm-3" v-if="user.role === 'Administrator'" v-show="$vuetify.breakpoint.smAndUp"/>
        <v-row justify="center" v-if="user.role === 'Administrator'">
            <v-col cols="12" sm="6" lg="4" class="text-center">
                <v-card outlined :to="{ name: 'Customers' }">
                    <v-card-title class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">
                        <v-icon>mdi-account-group</v-icon>&nbsp;&nbsp;Clientes
                    </v-card-title>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-text class="py-0">
                        <v-boilerplate type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" class="mx-auto" width="100%" v-if="adminShow === true"/>
                        <v-simple-table v-if="adminShow === false">
                            <template v-slot:default>
                                <tbody>
                                <template v-for="i in users">
                                    <tr class="transparent">
                                        <td>
                                            <v-avatar size="26px">
                                                <img :src="'/img/country/' + i.code + '.png'" :title="i.name" :alt="i.name.toLowerCase()" v-if="i.code"/>
                                                <v-icon large v-else>mdi-earth</v-icon>
                                            </v-avatar>
                                        </td>
                                        <td>{{ i.name }}</td>
                                        <td class="text-right">
                                            <strong>{{ (i.total).toLocaleString("en-US") }}</strong>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4" class="text-center">
                <v-card outlined :to="{ name: 'VPending' }">
                    <v-card-title class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">
                        <v-icon>mdi-swap-vertical-circle-outline</v-icon>&nbsp;&nbsp;Verificación
                    </v-card-title>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-text class="py-0">
                        <v-boilerplate type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" class="mx-auto" width="100%" v-if="adminShow === true"/>
                        <v-simple-table v-if="adminShow === false">
                            <template v-slot:default>
                                <tbody>
                                <template v-for="i in payments">
                                    <tr class="transparent">
                                        <td>
                                            <v-avatar size="26px">
                                                <img :src="'/img/country/' + i.code + '.png'" :title="i.name" :alt="i.name.toLowerCase()" v-if="i.code"/>
                                                <v-icon large v-else>mdi-earth</v-icon>
                                            </v-avatar>
                                        </td>
                                        <td>{{ i.name }}</td>
                                        <td class="text-right">
                                            <strong>{{ (i.total).toLocaleString("en-US") }}</strong>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4" class="text-center">
                <v-card outlined :to="{ name: 'TPending' }">
                    <v-card-title class="d-block text-center font-weight-bold primary--text py-0 py-md-2 trunck-text">
                        <v-icon>mdi-swap-horizontal-circle-outline</v-icon>&nbsp;&nbsp;Transferencias
                    </v-card-title>
                    <v-divider class="mx-2 mx-sm-4"/>
                    <v-card-text class="py-0">
                        <v-boilerplate type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" class="mx-auto" width="100%" v-if="adminShow === true"/>
                        <v-simple-table v-if="adminShow === false">
                            <template v-slot:default>
                                <tbody>
                                <template v-for="i in transfers">
                                    <tr class="transparent">
                                        <td>
                                            <v-avatar size="26px">
                                                <img :src="'/img/country/' + i.code + '.png'" :title="i.name" :alt="i.name.toLowerCase()" v-if="i.code"/>
                                                <v-icon large v-else>mdi-earth</v-icon>
                                            </v-avatar>
                                        </td>
                                        <td>{{ i.name }}</td>
                                        <td class="text-right">
                                            <strong>{{ (i.total).toLocaleString("en-US") }}</strong>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-btn bottom right fab fixed elevation="4" :color="(activity.status === true ? 'success' : 'primary')" @click="report = true" v-if="user.role !== 'Customer'">
            <v-icon large>mdi-calendar-clock</v-icon>
        </v-btn>
        <v-dialog
            v-model="receiveQrDialog"
            scrollable
            transition="dialog-bottom-transition"
            max-width="520px"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            :hide-overlay="$vuetify.breakpoint.xsOnly">
            <v-card class="wallet-modal-dialog wallet-qr-dialog">
                <v-card-title class="primary secondary--text wallet-fixed-header">
                    <v-spacer/>
                    Recibir
                    <v-spacer/>
                    <v-icon class="align-end" color="secondary" large @click="receiveQrDialog = false">mdi-close-circle</v-icon>
                </v-card-title>
                <v-card-text class="wallet-fixed-body pa-3 pa-sm-4">
                    <v-btn-toggle
                        v-model="receiveQrTab"
                        mandatory
                        dense
                        rounded
                        class="d-flex mb-3"
                        color="primary">
                        <v-btn value="valzum" class="flex-grow-1">
                            <v-icon left small>mdi-account-cash</v-icon>Valzum
                        </v-btn>
                        <v-btn value="crypto" class="flex-grow-1" :disabled="!crypto.enabled || !cryptoAssetItems.length">
                            <v-icon left small>mdi-link-variant</v-icon>Crypto
                        </v-btn>
                    </v-btn-toggle>

                    <div v-if="receiveQrTab === 'valzum'" class="text-center">
                        <div class="receive-qr-card mx-auto pa-5">
                            <h2 class="primary--text font-weight-bold mb-1">Escanea y paga</h2>
                            <div class="body-2 grey--text text--darken-1 mb-4">Paga directo con Valzum</div>
                            <div class="receive-qr-box mx-auto">
                                <vue-qrcode :value="qrValue" :scale="9" :margin="1" :version="3"/>
                                <img class="valzum-qr-center-logo" src="/img/favicon.png" alt="Valzum">
                            </div>
                            <div class="text-h5 primary--text font-weight-bold mt-4">{{ accountTag }}</div>
                        </div>
                    </div>

                    <div v-else>
                        <div class="crypto-asset-picker mb-3">
                            <div class="caption text-uppercase font-weight-bold primary--text mb-2">Moneda</div>
                            <v-chip-group
                                v-model="cryptoReceiveCurrency"
                                mandatory
                                column
                                active-class="crypto-asset-chip-active"
                                @change="onCryptoReceiveCurrencyChange">
                                <v-chip
                                    v-for="item in cryptoReceiveCurrencyItems"
                                    :key="'receive-dialog-currency-' + item.asset"
                                    :value="item.asset"
                                    label
                                    outlined
                                    class="crypto-asset-chip mr-2 mb-2">
                                    <span class="crypto-asset-symbol mr-2">{{ cryptoAssetSymbol(item.asset, item) }}</span>
                                    <span class="font-weight-bold">{{ item.asset }}</span>
                                </v-chip>
                            </v-chip-group>
                            <template v-if="cryptoReceiveNetworkItems.length">
                                <div class="caption text-uppercase font-weight-bold primary--text mt-2 mb-2">Red</div>
                                <v-chip-group
                                    v-model="cryptoReceiveAssetKey"
                                    mandatory
                                    column
                                    active-class="crypto-asset-chip-active"
                                    @change="onCryptoReceiveNetworkChange">
                                    <v-chip
                                        v-for="item in cryptoReceiveNetworkItems"
                                        :key="'receive-dialog-network-' + item.value"
                                        :value="item.value"
                                        label
                                        outlined
                                        class="crypto-asset-chip mr-2 mb-2">
                                        {{ item.network_label }}
                                    </v-chip>
                                </v-chip-group>
                            </template>
                        </div>
                        <v-btn
                            v-if="!selectedCryptoAddress"
                            block
                            outlined
                            color="primary"
                            :loading="cryptoAddressLoading"
                            :disabled="cryptoAddressLoading || !cryptoReceiveAssetKey"
                            @click="loadCryptoAddress">
                            <v-icon left>mdi-wallet-plus</v-icon> Generar direccion
                        </v-btn>
                        <div class="text-center mt-3" v-if="cryptoAddressLoading || selectedCryptoAddress">
                            <v-skeleton-loader v-if="cryptoAddressLoading" type="image, list-item-two-line"/>
                            <template v-else-if="selectedCryptoAddress">
                                <div class="receive-crypto-qr-card mx-auto pa-4">
                                    <h2 class="text-h6 primary--text font-weight-bold mb-2">
                                        {{ selectedCryptoAddress.asset }} · {{ selectedCryptoAddress.network_label }}
                                    </h2>
                                    <div class="receive-qr-box receive-crypto-qr-box mx-auto">
                                        <vue-qrcode :value="selectedCryptoAddress.qr_value" :scale="7" :margin="1" :version="4"/>
                                        <div class="crypto-qr-center-badge">
                                            <img
                                                v-if="cryptoAssetLogo(selectedCryptoAddress.asset, selectedCryptoAddress)"
                                                :src="cryptoAssetLogo(selectedCryptoAddress.asset, selectedCryptoAddress)"
                                                :alt="selectedCryptoAddress.asset"
                                                class="crypto-qr-center-logo">
                                            <span v-else>{{ cryptoAssetSymbol(selectedCryptoAddress.asset, selectedCryptoAddress) }}</span>
                                        </div>
                                    </div>
                                    <div class="caption primary--text font-weight-bold mt-2">Direccion</div>
                                    <div class="body-2 text-break">{{ selectedCryptoAddress.address }}</div>
                                    <div class="body-2 mt-1" v-if="selectedCryptoAddress.tag">Tag/Memo: {{ selectedCryptoAddress.tag }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="wallet-fixed-footer px-4 pb-4 pt-2">
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-btn
                                block
                                color="primary"
                                text
                                v-clipboard:copy="receiveQrTab === 'crypto' && selectedCryptoAddress ? selectedCryptoAddress.address : qrValue"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError"
                                :disabled="receiveQrTab === 'crypto' && !selectedCryptoAddress">
                                <v-icon left>mdi-content-copy</v-icon> {{ receiveQrTab === 'crypto' ? 'Copiar direccion' : 'Copiar' }}
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-btn
                                block
                                color="primary"
                                depressed
                                class="secondary--text"
                                :disabled="receiveQrTab === 'crypto' && !selectedCryptoAddress"
                                @click="receiveQrTab === 'crypto' ? downloadCryptoQr() : downloadReceiveQr()">
                                <v-icon left>mdi-download</v-icon> Descargar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dynamicConfirmDialog" persistent max-width="420px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card class="wallet-fixed-dialog">
                <v-card-title class="primary secondary--text d-flex align-center" style="word-break: normal">
                    <v-icon color="secondary" class="mr-2">mdi-cellphone-lock</v-icon>
                    Confirmar movimiento
                    <v-spacer/>
                    <v-btn icon color="secondary" :disabled="dynamicConfirmLoading" @click="cancelDynamicConfirmation">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="wallet-fixed-body pt-4">
                    <div class="text-center mb-4">
                        <v-avatar color="secondary" size="58" class="mb-3">
                            <v-icon color="primary" large>mdi-cellphone-key</v-icon>
                        </v-avatar>
                        <div class="subtitle-1 font-weight-bold primary--text">{{ dynamicConfirmTitle }}</div>
                        <div class="body-2 text--secondary mt-1">
                            Usa la clave de seguridad de tu app Valzum. Si no la tienes activa, puedes recibir una clave en tu correo registrado.
                        </div>
                    </div>
                    <v-alert
                        v-if="dynamicConfirmEmailStatus"
                        dense
                        text
                        type="success"
                        class="mb-4">
                        {{ dynamicConfirmEmailStatus }}
                    </v-alert>
                    <security-code-pad
                        v-model="dynamicConfirmCode"
                        :length="6"
                        :error-messages="dynamicConfirmError"
                        :disabled="dynamicConfirmLoading"
                        autofocus
                        @input="dynamicConfirmCode = onlyDynamicKeyDigits(dynamicConfirmCode)"
                        @complete="resolveDynamicConfirmation"
                        @submit="resolveDynamicConfirmation"/>
                    <v-btn
                        block
                        text
                        color="primary"
                        class="mt-2"
                        :loading="dynamicConfirmEmailLoading"
                        :disabled="dynamicConfirmLoading || dynamicConfirmEmailLoading"
                        @click="sendDynamicKeyEmailConfirmation">
                        <v-icon left>mdi-email-lock</v-icon>
                        {{ dynamicConfirmEmailSent ? 'Enviar otra clave al correo' : 'Enviar clave al correo' }}
                    </v-btn>
                </v-card-text>
                <v-divider/>
                <v-card-actions class="wallet-fixed-footer">
                    <v-btn text color="error" :disabled="dynamicConfirmLoading" @click="cancelDynamicConfirmation">
                        Cancelar
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        color="primary"
                        class="secondary--text"
                        :loading="dynamicConfirmLoading"
                        :disabled="dynamicConfirmCode.length !== 6"
                        @click="resolveDynamicConfirmation">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="report" scrollable max-width="600px">
            <v-card class="wallet-modal-dialog">
                <v-card-title class="wallet-fixed-header headline text-center d-block primary white--text">Reporte de Asistencia</v-card-title>
                <v-card-text class="wallet-fixed-body pt-4 text-h5 text-center" v-if="activity.status === true">
                    <h3 class="text-center font-weight-bold pb-2">Fecha y Hora de Ingreso</h3>
                    <h4 class="text-center">{{ new Date(activity.date) | moment("DD/MM/YYYY HH:mm") }}</h4>
                    <v-icon large class="pa-3">mdi-arrow-down-circle</v-icon>
                    <h3 class="text-center font-weight-bold pb-2">Fecha y Hora de Finalización</h3>
                    <h4 class="text-center">{{ now | moment("DD/MM/YYYY HH:mm") }}</h4>
                </v-card-text>
                <v-card-text class="wallet-fixed-body pt-4 text-h5 text-center" v-if="activity.status === false">
                    <h3 class="text-center font-weight-bold pb-2">Fecha y Hora de Ingreso</h3>
                    <h4 class="text-center">{{ now | moment("DD/MM/YYYY HH:mm") }}</h4>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="wallet-fixed-footer">
                    <v-btn color="error" @click="report = false">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="getReport('close')" v-if="activity.status">Finalizar</v-btn>
                    <v-btn color="success" @click="getReport('open')" v-else>Iniciar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from '../helpers/form';
    import {
        currencyDecimals as moneyCurrencyDecimals,
        currencyFieldConfig as moneyCurrencyFieldConfig,
        currencyMeta as moneyCurrencyMeta,
        currencySymbol as moneyCurrencySymbol,
        parseMoney
    } from '../helpers/money';
    import {settings} from "../config";
    import {devicePayload} from "../helpers/device";
    import {queryBrowserPermission, rememberPermissionState, storedPermissionState} from "../helpers/permissions";
    import SecurityCodePad from "../components/SecurityCodePad";
    import VueQrcode from 'vue-qrcode';
    import QRCode from 'qrcode';

    export default {
        name: "Home",
        mixins: [ Form ],
        props: [ 'user', 'useragent' ],
        components: {
            SecurityCodePad,
            VueQrcode,
            VBoilerplate: {
                functional: true,

                render(h, {data, props, children}) {
                    return h('v-skeleton-loader', {
                        ...data,
                        props: {
                            boilerplate: true,
                            elevation: 0,
                            ...props,
                        },
                    }, children)
                },
            }
        },
        data: () => ({
            loading: true,
            show: true,
            idValidator: false,
            idAdvance: 0,
            report: false,
            actions: [
                { name: "Recarga", icon: "cash-plus", action: "recharge" },
                { name: "Pide", icon: "cash-clock", action: "request" },
                { name: "Paga", icon: "cash-minus", action: "transfer" },
                { name: "Retira", icon: "cash-fast", action: "withdraw" },
            ],
            movements: [],
            transactions: [],
            balances: [],
            dynamicKeyLoading: false,
            dynamicKey: {
                enabled: false,
                code: null,
                period: 30,
                remaining: 0,
                expires_at: null,
                device_name: null
            },
            dynamicConfirmDialog: false,
            dynamicConfirmTitle: 'Confirma este movimiento',
            dynamicConfirmCode: '',
            dynamicConfirmError: '',
            dynamicConfirmLoading: false,
            dynamicConfirmEmailLoading: false,
            dynamicConfirmEmailSent: false,
            dynamicConfirmEmailStatus: '',
            dynamicConfirmChallengeId: '',
            dynamicConfirmPurpose: '',
            dynamicConfirmResolver: null,
            walletDialog: false,
            receiveQrDialog: false,
            receiveQrTab: 'valzum',
            walletMode: 'receive',
            walletLoading: false,
            walletValid: true,
            currencies: [],
            walletCurrency: 'USDC',
            selectedWalletCurrency: 'USDC',
            walletCurrencies: [],
            quoteOptions: {
                recharge: [],
                withdrawal: [],
                recharge_wallet_currencies: [],
                withdrawal_wallet_currencies: []
            },
            walletLimits: {
                recharge: {
                    minimums: {},
                    maximums: {}
                },
                withdrawal: {
                    minimums: {},
                    maximums: {}
                },
                pay: {
                    minimums: {},
                    maximums: {}
                },
                recharge_minimums: {}
            },
            agents: [],
            bankAccounts: [],
            paymentAccounts: [],
            walletContacts: [],
            paymentRequests: {
                incoming: [],
                outgoing: []
            },
            paymentRequestLoadingId: null,
            crypto: {
                enabled: false,
                assets: [],
                addresses: [],
                external_withdrawals: false
            },
            cryptoActivatingKey: null,
            cryptoReceiveCurrency: '',
            cryptoReceiveAssetKey: '',
            cryptoPayCurrency: '',
            cryptoAddressLoading: false,
            cryptoWithdrawalForm: {
                asset_key: '',
                amount: null,
                destination_address: '',
                destination_tag: '',
                note: ''
            },
            cryptoWithdrawalPreview: null,
            cryptoWithdrawalPreviewLoading: false,
            cryptoWithdrawalPreviewTimer: null,
            selectedWalletContactNickname: null,
            selectedRequestWalletContactNickname: null,
            userLocation: null,
            locationLoading: false,
            quoteLoading: {
                recharge: false,
                withdrawal: false
            },
            quoteErrors: {
                recharge: '',
                withdrawal: ''
            },
            quoteTimers: {
                recharge: null,
                withdrawal: null
            },
            quoteCountdown: {
                recharge: 0,
                withdrawal: 0
            },
            quoteLocalExpiresAt: {
                recharge: 0,
                withdrawal: 0
            },
            quoteAutoRefreshAt: {
                recharge: 0,
                withdrawal: 0
            },
            rechargeQuote: null,
            rechargeStep: 1,
            withdrawQuote: null,
            recipient: null,
            recipientLoading: false,
            requestRecipient: null,
            requestRecipientLoading: false,
            contactSaving: false,
            scanCamera: 'off',
            scanError: '',
            scanPermissionLoading: false,
            cameraPermissionState: storedPermissionState('camera'),
            locationPermissionState: storedPermissionState('geolocation'),
            scanRequestToken: 0,
            scanStreamKey: 0,
            scanCameraDevices: [],
            scanSelectedDeviceId: '',
            scanOriginalEnumerateDevices: null,
            scanOriginalGetUserMedia: null,
            scanCapabilities: {},
            scanFocusSupported: false,
            scanZoom: 1,
            scanZoomBounds: {
                min: 1,
                max: 1,
                step: 0.1
            },
            rechargeForm: {
                currency: 'USD',
                target_currency: 'USDC',
                amount: null,
                voucher: null,
                payment_account_id: null
            },
            payForm: {
                nickname: '',
                currency: 'USD',
                amount: null,
                note: '',
                save_contact: false
            },
            payDestination: 'valzum',
            requestForm: {
                nickname: '',
                currency: 'USDC',
                amount: null,
                note: ''
            },
            withdrawForm: {
                currency: 'USD',
                source_currency: 'USDC',
                amount: null,
                payout_method: 'bank',
                agent_office_id: null,
                customer_bank_account_id: null,
                note: ''
            },
            walletRules: {
                required: v => !!v || 'Campo obligatorio.'
            },
            rate_view: false,
            rate_countries: [
                { name: 'Venezuela', code: 'VEN', bank: null },
                { name: 'Colombia', code: 'COL', bank: null },
                { name: 'Perú', code: 'PER', bank: null },
                { name: 'Chile', code: 'CHL', bank: null },
                { name: 'Brasil', code: 'BRA', bank: null },
                { name: 'Ecuador', code: 'ECU', bank: null },
                { name: 'México', code: 'MEX', bank: null },
                { name: 'Panamá', code: 'PAN', bank: null },
                { name: 'Estados Unidos', code: 'USA', bank: null }
            ],
            rates: [],
            adminShow: true,
            countries: [
                { name: 'Venezuela', code: 'VEN' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Perú', code: 'PER' },
                { name: 'Europa', code: 'EUR' },
                { name: 'Argentina', code: 'ARG' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Brasil', code: 'BRA' },
                { name: 'México', code: 'MEX' },
                { name: 'Panamá', code: 'PAN' },
                { name: 'Estados Unidos', code: 'USA' }
            ],
            users: [],
            payments: [],
            transfers: [],
            nUsers: 0,
            nPayments: 0,
            nTransfers: 0,
            nComplete: 0,
            nTickets: 0,
            nOnlineCustomers: 0,
            activity: {
                status: false,
                date: new Date()
            },
            now: new Date(),
            look: false
        }),
        mounted() {
            window.addEventListener('valzum-session-confirmed', this.reloadAfterSessionConfirmation);
            this.getData(1);
            this.getDynamicKey();
            this.timer = setInterval(() => {
                this.now = new Date();
                this.tickQuotes();
                this.tickDynamicKey();
            }, 1000);
        },
        watch: {
            user() {
                this.show = true;
                this.getData();
                this.getDynamicKey();
            },
            'withdrawForm.payout_method'() {
                this.setDestinationDefaults();
                if (this.walletDialog && this.walletMode === 'withdraw') {
                    this.scheduleQuote('withdrawal');
                }
            },
            'cryptoWithdrawalForm.asset_key'() {
                const selected = this.selectedCryptoWithdrawalAsset;
                if (selected) {
                    this.cryptoPayCurrency = selected.asset;
                }
                this.scheduleCryptoWithdrawalPreview();
            },
            'cryptoWithdrawalForm.amount'() {
                this.scheduleCryptoWithdrawalPreview();
            }
        },
        computed:  {
            settings() {
                return settings;
            },
            accountTag() {
                return '$' + (this.user.nickname || (this.user.id ? String(this.user.id).padStart(5, '0') : ''));
            },
            qrValue() {
                return this.accountTag;
            },
            receiveNickname() {
                return this.cleanNickname(this.accountTag);
            },
            displayName() {
                return [this.user.name, this.user.lname].filter(Boolean).join(' ').trim();
            },
            walletTitle() {
                const titles = {
                    recharge: 'Recargar Wallet',
                    receive: 'Recibir',
                    request: 'Solicitar pago',
                    transfer: 'Pagar',
                    scan: 'Escanear QR',
                    withdraw: 'Retirar'
                };

                return titles[this.walletMode] || 'Wallet';
            },
            scanZoomSupported() {
                return Number(this.scanZoomBounds.max || 0) > Number(this.scanZoomBounds.min || 0);
            },
            scanCameraControlsVisible() {
                return this.scanZoomSupported || this.scanFocusSupported || (this.scanCameraDevices || []).length > 1;
            },
            balanceMap() {
                const balances = {};
                (this.balances || []).forEach(balance => {
                    const currency = String(balance.currency || '').toUpperCase();

                    if (!currency) {
                        return;
                    }

                    const amount = Number(balance.amount || 0);
                    const lockedAmount = Number(balance.locked_amount !== undefined ? balance.locked_amount : (balance.locked || 0));

                    if (!balances[currency]) {
                        balances[currency] = Object.assign({}, balance, {
                            currency: currency,
                            amount: Number.isFinite(amount) ? amount : 0,
                            locked_amount: Number.isFinite(lockedAmount) ? lockedAmount : 0,
                            formatted: balance.formatted || this.formatWalletAmount(currency, amount),
                            locked_formatted: balance.locked_formatted || this.formatWalletAmount(currency, lockedAmount),
                            _rows: 1
                        });
                        return;
                    }

                    balances[currency].amount += Number.isFinite(amount) ? amount : 0;
                    balances[currency].locked_amount += Number.isFinite(lockedAmount) ? lockedAmount : 0;
                    balances[currency]._rows += 1;
                    balances[currency].formatted = this.formatWalletAmount(currency, balances[currency].amount);
                    balances[currency].locked_formatted = this.formatWalletAmount(currency, balances[currency].locked_amount);
                });

                return balances;
            },
            selectedWalletCard() {
                return this.balanceCards.find(card => card.currency === this.selectedWalletCurrency) || this.balanceCards[0] || null;
            },
            primaryBalance() {
                return this.selectedWalletCard || { formatted: this.zeroBalanceText(this.walletCurrency), currency: this.walletCurrency };
            },
            walletCarouselTouch() {
                return {
                    left: () => this.nextWalletCard(),
                    right: () => this.previousWalletCard()
                };
            },
            balanceCards() {
                const codes = [];
                const addCode = code => {
                    const currency = String(code || '').toUpperCase();
                    if (currency && codes.indexOf(currency) === -1) {
                        codes.push(currency);
                    }
                };

                addCode(this.walletCurrency || 'USDC');
                (this.cryptoAssetItems || []).forEach(item => addCode(item.asset));
                (this.balances || []).forEach(balance => addCode(balance.currency));

                const ordered = codes.sort((a, b) => {
                    const priorityA = this.walletCurrencyPriority(a);
                    const priorityB = this.walletCurrencyPriority(b);

                    if (priorityA === priorityB) {
                        return a < b ? -1 : (a > b ? 1 : 0);
                    }

                    return priorityA - priorityB;
                });

                const cards = ordered.map(currency => {
                    const balance = this.balanceMap[currency] || null;
                    const networks = this.cryptoWalletItems.filter(item => item.asset === currency);
                    const activeNetworks = networks.filter(item => item.address_ready);
                    const pendingNetworks = networks.filter(item => !item.address_ready);

                    return {
                        currency: currency,
                        formatted: balance ? balance.formatted : this.zeroBalanceText(currency),
                        amount: balance ? balance.amount : 0,
                        locked: balance ? balance.locked_amount : 0,
                        icon: currency === 'EURC' ? 'currency-eur' : 'currency-usd',
                        networks: networks,
                        activeNetworks: activeNetworks,
                        pendingNetworks: pendingNetworks,
                        hasActiveNetwork: activeNetworks.length > 0
                    };
                });

                return cards.length ? cards : [{
                    currency: this.walletCurrency,
                    formatted: this.zeroBalanceText(this.walletCurrency),
                    amount: 0,
                    locked: 0,
                    icon: this.walletCurrency === 'EURC' ? 'currency-eur' : 'currency-usd',
                    networks: [],
                    activeNetworks: [],
                    pendingNetworks: [],
                    hasActiveNetwork: false
                }];
            },
            dynamicKeyProgress() {
                const period = Number(this.dynamicKey.period || 30);
                const remaining = Number(this.dynamicKey.remaining || 0);

                return period > 0 ? Math.max(0, Math.min(100, (remaining / period) * 100)) : 0;
            },
            rechargeCurrencies() {
                return this.paymentCurrencyItems(this.quoteOptions.recharge.length ? this.quoteOptions.recharge : this.currencies);
            },
            rechargeWalletCurrencies() {
                return this.quoteOptions.recharge_wallet_currencies && this.quoteOptions.recharge_wallet_currencies.length
                    ? this.quoteOptions.recharge_wallet_currencies
                    : this.walletCurrencyItems;
            },
            withdrawSourceCurrencies() {
                return this.quoteOptions.withdrawal_wallet_currencies && this.quoteOptions.withdrawal_wallet_currencies.length
                    ? this.quoteOptions.withdrawal_wallet_currencies
                    : this.walletCurrencyItems;
            },
            walletCurrencyItems() {
                if (this.walletCurrencies && this.walletCurrencies.length) {
                    return this.walletCurrencies;
                }

                return [{ code: this.walletCurrency, label: this.walletCurrency }];
            },
            rechargeWalletCurrency() {
                return this.rechargeForm.target_currency || this.walletCurrency;
            },
            withdrawSourceCurrency() {
                return this.withdrawForm.source_currency || this.walletCurrency;
            },
            rechargePaymentAccounts() {
                const currency = String(this.rechargeForm.currency || '').toUpperCase();

                return (this.paymentAccounts || []).filter(account => !currency || account.currency === currency);
            },
            selectedRechargePaymentAccount() {
                return this.rechargePaymentAccounts.find(account => account.id === this.rechargeForm.payment_account_id) || null;
            },
            rechargeDestinationReady() {
                return !!this.selectedRechargePaymentAccount;
            },
            rechargeAmountReady() {
                return !!this.rechargeForm.currency
                    && !!this.rechargeForm.target_currency
                    && this.walletAmountValue(this.rechargeForm.amount, this.rechargeForm.currency) > 0
                    && this.amountWithinLimits('recharge')
                    && !this.quoteErrors.recharge
                    && !this.quoteLoading.recharge
                    && this.canSubmitQuote('recharge');
            },
            rechargePaymentReady() {
                return this.rechargePaymentAccounts.length > 0 && !!this.selectedRechargePaymentAccount;
            },
            withdrawCurrencies() {
                return this.fiatCurrencyItems(this.quoteOptions.withdrawal.length ? this.quoteOptions.withdrawal : this.currencies);
            },
            withdrawalMethods() {
                const methods = [];

                if (this.agents.length > 0) {
                    methods.push({ text: 'Corresponsal/Agente', value: 'office' });
                }

                methods.push({ text: 'Transferencia/Deposito', value: 'bank' });

                return methods;
            },
            cryptoSendOptionVisible() {
                return this.user && this.user.role === 'Customer';
            },
            canSendCryptoExternally() {
                return this.crypto.enabled && this.crypto.external_withdrawals && this.cryptoAssetItems.length > 0;
            },
            cryptoSendUnavailableReason() {
                if (!this.crypto.enabled) {
                    return 'Admin debe activar las billeteras digitales.';
                }

                if (!this.cryptoAssetItems.length) {
                    return 'Admin debe activar al menos una moneda y ruta.';
                }

                if (!this.crypto.external_withdrawals) {
                    return 'Admin debe activar los envios externos.';
                }

                return '';
            },
            cryptoAssetItems() {
                return (this.crypto.assets || []).map(item => ({
                    text: (item.label || (item.asset + ' - ' + item.network)) + (item.preferred_route ? ' · recomendada' : ''),
                    value: this.cryptoAssetKey(item),
                    asset: item.asset,
                    symbol: this.cryptoAssetSymbol(item.asset, item),
                    symbol_native: this.cryptoAssetSymbol(item.asset, item),
                    logo_url: item.logo_url || this.currencyLogo(item.asset),
                    network: item.network,
                    network_label: item.network_label || item.network,
                    provider: item.provider,
                    network_fee_estimate: Number(item.network_fee_estimate || 0),
                    preferred_network: item.preferred_network || null,
                    preferred_route: !!item.preferred_route,
                    balance_scope: item.balance_scope || 'currency',
                    account_ready: !!item.account_ready,
                    address_ready: !!item.address_ready,
                    active: !!item.active,
                    default_activation: !!item.default_activation
                }));
            },
            cryptoReceiveCurrencyItems() {
                const currencies = [];

                this.cryptoAssetItems.forEach(item => {
                    if (!currencies.some(currency => currency.asset === item.asset)) {
                        currencies.push({
                            asset: item.asset,
                            symbol: this.cryptoAssetSymbol(item.asset, item),
                            logo_url: this.cryptoAssetLogo(item.asset, item)
                        });
                    }
                });

                return currencies;
            },
            cryptoReceiveNetworkItems() {
                return this.cryptoAssetItems.filter(item => item.asset === this.cryptoReceiveCurrency);
            },
            cryptoPayCurrencyItems() {
                return this.cryptoReceiveCurrencyItems;
            },
            cryptoPayNetworkItems() {
                return this.cryptoAssetItems.filter(item => item.asset === this.cryptoPayCurrency);
            },
            cryptoWalletItems() {
                const balances = {};
                (this.balances || []).forEach(balance => {
                    balances[String(balance.currency || '').toUpperCase()] = balance;
                });

                return this.cryptoAssetItems.map(item => {
                    const address = this.cryptoAddressFor(item);
                    const balance = balances[item.asset] || null;
                    const addressReady = !!address;

                    return Object.assign({}, item, {
                        key: item.value,
                        symbol: this.cryptoAssetSymbol(item.asset, item),
                        providerLabel: this.cryptoProviderLabel(item.provider),
                        address: address,
                        address_ready: addressReady,
                        active: addressReady,
                        statusText: addressReady ? 'Activa' : (item.account_ready ? 'Falta direccion' : 'Por activar'),
                        statusColor: addressReady ? 'success' : 'warning',
                        formattedBalance: balance ? balance.formatted : this.zeroBalanceText(item.asset),
                        addressText: addressReady ? this.shortAddress(address.address) : 'Lista para activar en ' + (item.network_label || item.network)
                    });
                });
            },
            cryptoPendingWalletItems() {
                return this.cryptoWalletItems.filter(item => !item.address_ready);
            },
            cryptoInitialWalletItems() {
                return this.cryptoWalletItems.filter(item => item.default_activation);
            },
            cryptoInitialActivationDisabled() {
                return !!this.cryptoActivatingKey
                    || this.cryptoInitialWalletItems.length === 0
                    || this.cryptoInitialWalletItems.every(item => item.address_ready);
            },
            selectedCryptoReceiveAsset() {
                return this.cryptoAssetFromKey(this.cryptoReceiveAssetKey);
            },
            selectedCryptoAddress() {
                const selected = this.selectedCryptoReceiveAsset;

                if (!selected) {
                    return null;
                }

                return (this.crypto.addresses || []).find(item => item.asset === selected.asset && item.network === selected.network) || null;
            },
            selectedCryptoWithdrawalAsset() {
                return this.cryptoAssetFromKey(this.cryptoWithdrawalForm.asset_key);
            },
            cryptoWithdrawalCurrency() {
                const selected = this.selectedCryptoWithdrawalAsset;

                return selected ? selected.asset : this.walletCurrency;
            },
            cryptoWithdrawalRules() {
                return [
                    this.walletRules.required,
                    value => this.walletAmountValue(value, this.cryptoWithdrawalCurrency) > 0 || 'El monto debe ser mayor a cero.',
                    this.cryptoWithdrawalBalanceRule
                ];
            },
            cryptoWithdrawalReady() {
                return !!this.selectedCryptoWithdrawalAsset
                    && this.walletAmountValue(this.cryptoWithdrawalForm.amount, this.cryptoWithdrawalCurrency) > 0
                    && !!this.cryptoWithdrawalForm.destination_address;
            },
            cryptoWithdrawalFeePreview() {
                const selected = this.selectedCryptoWithdrawalAsset;
                if (!selected) {
                    return null;
                }

                const currency = selected.asset;
                const amount = this.walletAmountValue(this.cryptoWithdrawalForm.amount, currency);
                if (amount <= 0) {
                    return null;
                }

                if (this.cryptoWithdrawalPreview
                    && this.cryptoWithdrawalPreview.asset === selected.asset
                    && this.cryptoWithdrawalPreview.network === selected.network
                    && Math.abs(Number(this.cryptoWithdrawalPreview.amount || 0) - amount) <= 0.00000001) {
                    const fee = this.cryptoWithdrawalPreview.fee || {};

                    return {
                        raw_amount: Number(this.cryptoWithdrawalPreview.amount || 0),
                        raw_valzum_fee: Number(fee.valzum_fee_amount || 0),
                        raw_network_fee: Number(fee.network_fee_amount || 0),
                        raw_total_fee: Number(fee.total_fee_amount || 0),
                        raw_total: Number(this.cryptoWithdrawalPreview.total_debit_amount || 0),
                        amount: this.cryptoWithdrawalPreview.amount_formatted,
                        valzum_fee: fee.valzum_fee_formatted,
                        network_fee: fee.network_fee_formatted,
                        total_fee: fee.total_fee_formatted,
                        total: this.cryptoWithdrawalPreview.total_debit_formatted
                    };
                }

                const feeSettings = this.crypto.withdrawal_fee || {};
                const percent = Number(feeSettings.percent || 0);
                const fixed = Number(feeSettings.fixed || 0);
                const valzumFee = this.roundWalletAmount(currency, (amount * percent / 100) + fixed);
                const networkFee = this.roundWalletAmount(currency, Number(selected.network_fee_estimate || 0));
                const totalFee = this.roundWalletAmount(currency, valzumFee + networkFee);
                const total = this.roundWalletAmount(currency, amount + totalFee);

                return {
                    raw_amount: amount,
                    raw_valzum_fee: valzumFee,
                    raw_network_fee: networkFee,
                    raw_total_fee: totalFee,
                    raw_total: total,
                    amount: this.formatWalletAmount(currency, amount),
                    valzum_fee: this.formatWalletAmount(currency, valzumFee),
                    network_fee: this.formatWalletAmount(currency, networkFee),
                    total_fee: this.formatWalletAmount(currency, totalFee),
                    total: this.formatWalletAmount(currency, total)
                };
            },
            rechargeMinimum() {
                return this.amountLimit('recharge', 'min');
            },
            rechargeMaximum() {
                return this.amountLimit('recharge', 'max');
            },
            rechargeLimitText() {
                return this.amountLimitText('recharge');
            },
            withdrawLimitText() {
                return this.amountLimitText('withdrawal');
            },
            payLimitText() {
                return this.amountLimitText('pay');
            },
            requestLimitText() {
                return this.amountLimitText('request');
            },
            rechargeRules() {
                return [this.walletRules.required, this.amountLimitRule('recharge')];
            },
            withdrawRules() {
                return [this.walletRules.required, this.amountLimitRule('withdrawal')];
            },
            payRules() {
                return [this.walletRules.required, this.amountLimitRule('pay')];
            },
            requestRules() {
                return [this.walletRules.required, this.amountLimitRule('request')];
            },
            incomingPaymentRequests() {
                return this.paymentRequests && this.paymentRequests.incoming ? this.paymentRequests.incoming : [];
            },
            outgoingPaymentRequests() {
                return this.paymentRequests && this.paymentRequests.outgoing ? this.paymentRequests.outgoing : [];
            },
            agentsWithDistance() {
                const items = (this.agents || []).map(agent => {
                    const distance = this.agentDistance(agent);
                    return Object.assign({}, agent, {
                        distance: distance,
                        display: agent.name + (agent.city ? ' - ' + agent.city : '') + (distance !== null ? ' - ' + this.formatDistance(distance) : '')
                    });
                });

                return items.sort((a, b) => {
                    if (a.distance === null && b.distance === null) return a.name.localeCompare(b.name);
                    if (a.distance === null) return 1;
                    if (b.distance === null) return -1;
                    return a.distance - b.distance;
                });
            },
            selectedAgent() {
                return this.agentsWithDistance.find(agent => agent.id === this.withdrawForm.agent_office_id) || null;
            },
            selectedBankAccount() {
                return this.bankAccounts.find(account => account.id === this.withdrawForm.customer_bank_account_id) || null;
            },
            walletContactItems() {
                return (this.walletContacts || []).filter(contact => contact.is_favorite).map(contact => ({
                    text: contact.label + ' - ' + contact.nickname,
                    value: contact.raw_nickname || this.cleanNickname(contact.nickname),
                    disabled: !contact.verified
                }));
            },
            recipientIsWalletContact() {
                if (!this.recipient) {
                    return false;
                }

                const nickname = this.cleanNickname(this.recipient.nickname);

                return (this.walletContacts || []).some(contact => this.cleanNickname(contact.nickname) === nickname);
            },
            payCurrencies() {
                return this.balanceCards.map(balance => ({
                    code: balance.currency,
                    label: balance.currency
                }));
            },
            requestCurrencies() {
                return this.payCurrencies;
            },
            isNativeApp() {
                const payload = this.devicePayload();
                const device = String(payload.device || '').toLowerCase();

                return payload.name === 'Valzum'
                    && ['android', 'ios', 'iphone', 'ipad'].indexOf(device) !== -1
                    && !!(payload.device_uid || payload.ios_id || payload.fcm_token);
            },
            browserDynamicKeyRequired() {
                return this.user && this.user.role === 'Customer' && !this.isNativeApp;
            }
        },
        methods: {
            devicePayload() {
                return devicePayload();
            },
            sensitivePayload(title, purpose) {
                const payload = {
                    device_info: this.devicePayload()
                };

                if (!this.browserDynamicKeyRequired) {
                    return Promise.resolve(payload);
                }

                return this.requestDynamicKeyConfirmation(title, purpose).then(security => Object.assign(payload, {
                    dynamic_key: security.code,
                    dynamic_key_challenge_id: security.challenge_id || null
                }));
            },
            requestDynamicKeyConfirmation(title, purpose) {
                return new Promise((resolve, reject) => {
                    this.dynamicConfirmTitle = title || 'Confirma este movimiento';
                    this.dynamicConfirmCode = '';
                    this.dynamicConfirmError = '';
                    this.dynamicConfirmLoading = false;
                    this.dynamicConfirmEmailLoading = false;
                    this.dynamicConfirmEmailSent = false;
                    this.dynamicConfirmEmailStatus = '';
                    this.dynamicConfirmChallengeId = '';
                    this.dynamicConfirmPurpose = purpose || 'wallet_pay';
                    this.dynamicConfirmResolver = {resolve, reject};
                    this.dynamicConfirmDialog = true;
                });
            },
            resolveDynamicConfirmation() {
                this.dynamicConfirmCode = this.onlyDynamicKeyDigits(this.dynamicConfirmCode);

                if (this.dynamicConfirmCode.length !== 6 || !this.dynamicConfirmResolver) {
                    this.dynamicConfirmError = 'Ingresa los 6 numeros de la clave.';
                    return;
                }

                const resolver = this.dynamicConfirmResolver;
                const challengeId = this.dynamicConfirmChallengeId;
                this.dynamicConfirmResolver = null;
                this.dynamicConfirmDialog = false;
                resolver.resolve({
                    code: this.dynamicConfirmCode,
                    challenge_id: challengeId
                });
            },
            sendDynamicKeyEmailConfirmation() {
                if (this.dynamicConfirmEmailLoading || !this.dynamicConfirmResolver) {
                    return;
                }

                this.dynamicConfirmEmailLoading = true;
                this.dynamicConfirmError = '';
                axios.post('/api/security/dynamic-key/email', {
                    purpose: this.dynamicConfirmPurpose || 'wallet_pay',
                    device_info: this.devicePayload()
                }).then(res => {
                    this.dynamicConfirmChallengeId = res.data.challenge_id || '';
                    this.dynamicConfirmEmailSent = true;
                    this.dynamicConfirmEmailStatus = res.data.status || 'Enviamos la clave al correo registrado.';
                }).catch(err => {
                    this.dynamicConfirmError = this.errorMessage(err, 'No fue posible enviar la clave al correo.');
                }).then(() => {
                    this.dynamicConfirmEmailLoading = false;
                });
            },
            cancelDynamicConfirmation() {
                if (this.dynamicConfirmResolver) {
                    this.dynamicConfirmResolver.reject(new Error('cancelled'));
                }

                this.dynamicConfirmResolver = null;
                this.dynamicConfirmDialog = false;
                this.dynamicConfirmCode = '';
                this.dynamicConfirmError = '';
                this.dynamicConfirmLoading = false;
                this.dynamicConfirmEmailLoading = false;
                this.dynamicConfirmEmailSent = false;
                this.dynamicConfirmEmailStatus = '';
                this.dynamicConfirmChallengeId = '';
                this.dynamicConfirmPurpose = '';
            },
            onlyDynamicKeyDigits(value) {
                return String(value || '').replace(/\D/g, '').slice(0, 6);
            },
            getDynamicKey() {
                if (!this.user || this.user.role !== 'Customer' || this.dynamicKeyLoading) return;

                this.dynamicKeyLoading = true;
                axios.get('/api/security/dynamic-key', {
                    params: {
                        device_info: this.devicePayload()
                    }
                }).then(res => {
                    this.setDynamicKey(res.data.dynamic_key || null);
                }).catch(() => {
                    this.setDynamicKey(null);
                }).then(() => {
                    this.dynamicKeyLoading = false;
                });
            },
            setDynamicKey(payload) {
                this.dynamicKey = Object.assign({
                    enabled: false,
                    code: null,
                    period: 30,
                    remaining: 0,
                    expires_at: null,
                    device_name: null,
                    app_required: false,
                    manual_entry: false,
                    can_rotate: false,
                    rotation_expires_at: null,
                    rotation_due: false
                }, payload || {});
            },
            tickDynamicKey() {
                if (!this.dynamicKey.enabled || !this.dynamicKey.expires_at) return;

                const expiresAt = Date.parse(this.dynamicKey.expires_at);
                if (!expiresAt) return;

                const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
                this.$set(this.dynamicKey, 'remaining', remaining);

                if (remaining <= 1) {
                    this.getDynamicKey();
                }
            },
            openReceiveQrDialog(preferredCryptoKey) {
                this.stopScanner();
                this.receiveQrDialog = true;
                this.receiveQrTab = 'valzum';

                this.ensureWalletData().then(() => {
                    this.setWalletCurrencyDefault();

                    if (preferredCryptoKey) {
                        this.ensureCryptoReceiveSelection(preferredCryptoKey);
                        return;
                    }

                    const card = this.selectedWalletCard;
                    if (card && card.activeNetworks && card.activeNetworks.length) {
                        this.ensureCryptoReceiveSelection(card.activeNetworks[0].key);
                    }
                });
            },
            openWallet(mode) {
                this.walletMode = mode;
                this.walletDialog = true;
                this.walletValid = true;
                this.scanError = '';

                this.ensureWalletData().then(() => {
                    if (mode === 'recharge') {
                        this.rechargeStep = 1;
                        this.scheduleQuote('recharge');
                    }
                    if (mode === 'transfer') {
                        this.setPayDestination('valzum');
                    }
                    if (mode === 'withdraw') {
                        this.requestLocation();
                        this.setDestinationDefaults();
                        this.scheduleQuote('withdrawal');
                    }
                });

                if (mode === 'scan') {
                    this.$nextTick(() => {
                        this.startScanner();
                    });
                } else {
                    this.stopScanner();
                }
            },
            setPayDestination(destination) {
                this.payDestination = destination;
                this.walletValid = true;
                this.stopScanner();

                if (destination === 'crypto') {
                    this.setCryptoDefaults();
                    this.scheduleCryptoWithdrawalPreview();
                } else {
                    clearTimeout(this.cryptoWithdrawalPreviewTimer);
                    this.cryptoWithdrawalPreview = null;
                    this.cryptoWithdrawalPreviewLoading = false;
                }
            },
            focusPayNickname() {
                this.setPayDestination('valzum');
                this.$nextTick(() => {
                    if (this.$refs.payNicknameField && this.$refs.payNicknameField.focus) {
                        this.$refs.payNicknameField.focus();
                    }
                });
            },
            openCryptoWithdrawalShortcut() {
                this.walletMode = 'transfer';
                this.payDestination = 'crypto';
                this.walletValid = true;
                this.walletDialog = true;
                this.stopScanner();

                this.ensureWalletData().then(() => {
                    this.setCryptoDefaults();
                    this.scheduleCryptoWithdrawalPreview();
                });
            },
            closeWallet() {
                this.walletDialog = false;
                this.stopScanner();
                this.scanError = '';
            },
            returnFromScanner() {
                this.walletMode = 'transfer';
                this.payDestination = 'valzum';
                this.walletValid = true;
                this.stopScanner();
                this.scanError = '';
            },
            walletDialogChanged(value) {
                if (!value) {
                    this.stopScanner();
                }
            },
            stopScanner() {
                this.scanRequestToken += 1;
                this.scanPermissionLoading = false;
                this.scanCamera = 'off';
                this.scanCapabilities = {};
                this.scanFocusSupported = false;
                this.restoreScannerMediaOverrides();
            },
            async startScanner() {
                this.scanError = '';
                this.scanCamera = 'off';
                this.restoreScannerMediaOverrides();

                if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
                    this.scanError = 'La camara no esta disponible en este dispositivo.';
                    return;
                }

                const token = this.scanRequestToken + 1;
                this.scanRequestToken = token;
                this.scanPermissionLoading = true;

                try {
                    const permissionState = await queryBrowserPermission('camera', 'camera');
                    this.cameraPermissionState = permissionState;

                    if (permissionState === 'denied') {
                        this.scanError = 'La camara esta bloqueada. Activa el permiso en la configuracion del dispositivo o navegador.';
                        return;
                    }

                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: false,
                        video: {
                            facingMode: { ideal: 'environment' }
                        }
                    });

                    stream.getTracks().forEach(track => track.stop());
                    rememberPermissionState('camera', 'granted');
                    this.cameraPermissionState = 'granted';
                    await this.loadScannerCameraDevices();
                    this.ensureScannerCameraSelection();

                    if (this.scanRequestToken !== token || !this.walletDialog || this.walletMode !== 'scan') {
                        return;
                    }

                    this.applyScannerDevicePreference();
                    this.scanStreamKey += 1;
                    this.scanCamera = this.scanSelectedCameraFacing();
                } catch (error) {
                    if (this.scanRequestToken === token) {
                        if (error && ['NotAllowedError', 'PermissionDeniedError', 'SecurityError'].indexOf(error.name) !== -1) {
                            rememberPermissionState('camera', 'denied');
                            this.cameraPermissionState = 'denied';
                        }
                        this.scanError = this.cameraErrorMessage(error);
                    }
                } finally {
                    if (this.scanRequestToken === token) {
                        this.scanPermissionLoading = false;
                    }
                }
            },
            async loadScannerCameraDevices() {
                if (!navigator.mediaDevices || typeof navigator.mediaDevices.enumerateDevices !== 'function') {
                    this.scanCameraDevices = [];
                    return [];
                }

                try {
                    const devices = await navigator.mediaDevices.enumerateDevices();
                    this.scanCameraDevices = devices.filter(device => device.kind === 'videoinput');
                } catch (error) {
                    this.scanCameraDevices = [];
                }

                return this.scanCameraDevices;
            },
            cameraDeviceLabel(device, index) {
                const label = String(device && device.label ? device.label : '').trim();

                return label || 'Camara ' + (index + 1);
            },
            cameraLabelIsFront(label) {
                return /(front|frontal|selfie|user|facetime|delantera|avant|voorzijde)/i.test(label || '');
            },
            cameraLabelIsBack(label) {
                return /(back|rear|environment|trasera|posterior|rückseitige|zadn|arrière|traseira|detras)/i.test(label || '');
            },
            cameraLabelIsSpecial(label) {
                return /(ultra|wide|gran angular|tele|telephoto|dual|triple|desk|obs|virtual|infrared|ir)/i.test(label || '');
            },
            bestScannerCameraDevice() {
                const devices = this.scanCameraDevices || [];

                if (!devices.length) {
                    return null;
                }

                const items = devices.map((device, index) => ({
                    device: device,
                    label: this.cameraDeviceLabel(device, index)
                }));
                const standardBack = items.filter(item => this.cameraLabelIsBack(item.label) && !this.cameraLabelIsSpecial(item.label));

                if (standardBack.length) {
                    return standardBack[standardBack.length - 1].device;
                }

                const back = items.filter(item => this.cameraLabelIsBack(item.label));
                if (back.length) {
                    return back[back.length - 1].device;
                }

                const notFront = items.filter(item => !this.cameraLabelIsFront(item.label));
                if (notFront.length) {
                    return notFront[notFront.length - 1].device;
                }

                return devices[devices.length - 1];
            },
            ensureScannerCameraSelection() {
                const devices = this.scanCameraDevices || [];

                if (!devices.length) {
                    this.scanSelectedDeviceId = '';
                    return;
                }

                if (this.scanSelectedDeviceId && devices.some(device => device.deviceId === this.scanSelectedDeviceId)) {
                    return;
                }

                const best = this.bestScannerCameraDevice();
                this.scanSelectedDeviceId = best ? best.deviceId : devices[devices.length - 1].deviceId;
            },
            selectedScannerCameraDevice() {
                return (this.scanCameraDevices || []).find(device => device.deviceId === this.scanSelectedDeviceId) || null;
            },
            scanSelectedCameraFacing() {
                const selected = this.selectedScannerCameraDevice();
                const index = Math.max(0, (this.scanCameraDevices || []).findIndex(device => device.deviceId === this.scanSelectedDeviceId));
                const label = selected ? this.cameraDeviceLabel(selected, index) : '';

                return this.cameraLabelIsFront(label) ? 'front' : 'rear';
            },
            applyScannerDevicePreference() {
                this.restoreScannerMediaOverrides();

                if (!this.scanSelectedDeviceId || !navigator.mediaDevices || typeof navigator.mediaDevices.enumerateDevices !== 'function') {
                    return;
                }

                const selectedId = this.scanSelectedDeviceId;
                const facing = this.scanSelectedCameraFacing();
                const original = navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
                this.scanOriginalEnumerateDevices = original;

                try {
                    navigator.mediaDevices.enumerateDevices = async () => {
                        const devices = await original();
                        const selected = devices.find(device => device.kind === 'videoinput' && device.deviceId === selectedId);

                        if (!selected) {
                            return devices;
                        }

                        const others = devices.filter(device => device.deviceId !== selectedId);
                        const selectedForReader = Object.assign({}, selected, {
                            label: 'Camara seleccionada Valzum'
                        });

                        return facing === 'front'
                            ? [selectedForReader].concat(others)
                            : others.concat([selectedForReader]);
                    };
                } catch (error) {
                    this.scanOriginalEnumerateDevices = null;
                }

                if (typeof navigator.mediaDevices.getUserMedia === 'function') {
                    const originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
                    this.scanOriginalGetUserMedia = originalGetUserMedia;

                    try {
                        navigator.mediaDevices.getUserMedia = constraints => {
                            return originalGetUserMedia(this.scannerMediaConstraints(constraints, selectedId));
                        };
                    } catch (error) {
                        this.scanOriginalGetUserMedia = null;
                    }
                }
            },
            scannerMediaConstraints(constraints, selectedId) {
                const next = Object.assign({}, constraints || {});
                const currentVideo = typeof next.video === 'object' && next.video !== null ? next.video : {};
                const advanced = Array.isArray(currentVideo.advanced) ? currentVideo.advanced.slice() : [];

                advanced.unshift(
                    { focusMode: 'continuous' },
                    { exposureMode: 'continuous' },
                    { whiteBalanceMode: 'continuous' }
                );

                next.audio = false;
                next.video = Object.assign({}, currentVideo, {
                    deviceId: { exact: selectedId },
                    width: { min: 360, ideal: 1280, max: 1920 },
                    height: { min: 240, ideal: 720, max: 1080 },
                    advanced: advanced
                });

                return next;
            },
            restoreScannerMediaOverrides() {
                if (this.scanOriginalEnumerateDevices && navigator.mediaDevices) {
                    try {
                        navigator.mediaDevices.enumerateDevices = this.scanOriginalEnumerateDevices;
                    } catch (error) {
                        // Some webviews expose read-only mediaDevices methods.
                    }
                }

                if (this.scanOriginalGetUserMedia && navigator.mediaDevices) {
                    try {
                        navigator.mediaDevices.getUserMedia = this.scanOriginalGetUserMedia;
                    } catch (error) {
                        // Some webviews expose read-only mediaDevices methods.
                    }
                }

                this.scanOriginalEnumerateDevices = null;
                this.scanOriginalGetUserMedia = null;
            },
            switchScannerCamera() {
                if (!this.walletDialog || this.walletMode !== 'scan') {
                    return;
                }

                this.scanCamera = 'off';
                this.scanError = '';
                this.scanStreamKey += 1;
                this.$nextTick(() => {
                    this.applyScannerDevicePreference();
                    this.scanStreamKey += 1;
                    this.scanCamera = this.scanSelectedCameraFacing();
                });
            },
            cycleScannerCamera() {
                const devices = this.scanCameraDevices || [];

                if (devices.length <= 1) {
                    return;
                }

                const current = devices.findIndex(device => device.deviceId === this.scanSelectedDeviceId);
                const next = devices[(current + 1 + devices.length) % devices.length];

                if (!next) {
                    return;
                }

                this.scanSelectedDeviceId = next.deviceId;
                this.switchScannerCamera();
            },
            scannerVideoTrack() {
                const streamComponent = this.$refs.walletQrStream;
                const video = streamComponent && streamComponent.$refs ? streamComponent.$refs.video : null;
                const stream = video ? video.srcObject : null;

                if (!stream || typeof stream.getVideoTracks !== 'function') {
                    return null;
                }

                return stream.getVideoTracks()[0] || null;
            },
            prepareScannerTrackControls(capabilities) {
                const track = this.scannerVideoTrack();
                const trackCapabilities = track && typeof track.getCapabilities === 'function' ? track.getCapabilities() : {};
                const nextCapabilities = Object.assign({}, capabilities || {}, trackCapabilities || {});

                this.scanCapabilities = nextCapabilities;
                this.scanFocusSupported = this.scannerFocusSupported(nextCapabilities);
                this.configureScannerZoom(nextCapabilities, track);
                this.applyScannerFocus();
            },
            scannerFocusSupported(capabilities) {
                const focusModes = capabilities && capabilities.focusMode;

                return Array.isArray(focusModes)
                    ? focusModes.some(mode => ['continuous', 'single-shot', 'manual'].indexOf(mode) !== -1)
                    : !!(capabilities && capabilities.focusDistance);
            },
            configureScannerZoom(capabilities, track) {
                const zoom = capabilities && capabilities.zoom;

                if (!zoom || typeof zoom !== 'object') {
                    this.scanZoomBounds = { min: 1, max: 1, step: 0.1 };
                    this.scanZoom = 1;
                    return;
                }

                const min = Number(zoom.min || 1);
                const max = Number(zoom.max || min);
                const step = Number(zoom.step || 0.1);
                const settings = track && typeof track.getSettings === 'function' ? track.getSettings() : {};
                const current = Number(settings.zoom || 0);
                const preferred = current || Math.min(max, Math.max(min, min + ((max - min) * 0.15)));

                this.scanZoomBounds = {
                    min: min,
                    max: max,
                    step: step > 0 ? step : 0.1
                };
                this.scanZoom = this.clampScannerNumber(preferred, min, max);
                this.applyScannerZoom(this.scanZoom);
            },
            applyScannerZoom(value) {
                const track = this.scannerVideoTrack();

                if (!track || typeof track.applyConstraints !== 'function' || !this.scanZoomSupported) {
                    return;
                }

                const zoom = this.clampScannerNumber(value, this.scanZoomBounds.min, this.scanZoomBounds.max);
                this.scanZoom = zoom;

                try {
                    const result = track.applyConstraints({ advanced: [{ zoom: zoom }] });

                    if (result && typeof result.catch === 'function') {
                        result.catch(() => {});
                    }
                } catch (error) {
                    // Camera capabilities vary between browsers and native webviews.
                }
            },
            applyScannerFocus() {
                const track = this.scannerVideoTrack();

                if (!track || typeof track.applyConstraints !== 'function') {
                    return;
                }

                const capabilities = this.scanCapabilities || {};
                const focusModes = capabilities.focusMode;
                const exposureModes = capabilities.exposureMode;
                const whiteBalanceModes = capabilities.whiteBalanceMode;
                const advanced = [];

                if (Array.isArray(focusModes)) {
                    if (focusModes.indexOf('continuous') !== -1) {
                        advanced.push({ focusMode: 'continuous' });
                    } else if (focusModes.indexOf('single-shot') !== -1) {
                        advanced.push({ focusMode: 'single-shot' });
                    }
                }

                if (Array.isArray(exposureModes) && exposureModes.indexOf('continuous') !== -1) {
                    advanced.push({ exposureMode: 'continuous' });
                }

                if (Array.isArray(whiteBalanceModes) && whiteBalanceModes.indexOf('continuous') !== -1) {
                    advanced.push({ whiteBalanceMode: 'continuous' });
                }

                if (!advanced.length) {
                    return;
                }

                try {
                    const result = track.applyConstraints({ advanced: advanced });

                    if (result && typeof result.catch === 'function') {
                        result.catch(() => {});
                    }
                } catch (error) {
                    // Camera capabilities vary between browsers and native webviews.
                }
            },
            clampScannerNumber(value, min, max) {
                const number = Number(value);

                if (!Number.isFinite(number)) {
                    return min;
                }

                return Math.min(max, Math.max(min, number));
            },
            ensureWalletData() {
                return axios.get('/api/wallet').then(res => {
                    this.currencies = res.data.currencies || [];
                    this.walletCurrency = res.data.wallet_currency || this.walletCurrency;
                    this.walletCurrencies = res.data.wallet_currencies || this.walletCurrencies;
                    this.quoteOptions = res.data.quote_options || this.quoteOptions;
                    this.walletLimits = res.data.limits || this.walletLimits;
                    this.agents = res.data.agents || [];
                    this.bankAccounts = res.data.bank_accounts || [];
                    this.paymentAccounts = res.data.payment_accounts || [];
                    this.walletContacts = res.data.contacts || this.walletContacts;
                    this.paymentRequests = res.data.payment_requests || this.paymentRequests;
                    this.crypto = res.data.crypto || this.crypto;
                    this.balances = res.data.balances || this.balances;
                    this.setCurrencyDefaults();
                    this.setCryptoDefaults();
                    this.setWalletCurrencyDefault();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible cargar el wallet.'), {icon: 'mdi-alert-circle'});
                });
            },
            setWalletCurrencyDefault() {
                const cards = this.balanceCards || [];

                if (!cards.length) {
                    return;
                }

                if (!this.selectedWalletCurrency || !cards.some(card => card.currency === this.selectedWalletCurrency)) {
                    const preferred = cards.find(card => card.currency === this.walletCurrency) || cards[0];
                    this.selectedWalletCurrency = preferred.currency;
                }
            },
            setCryptoDefaults() {
                this.ensureCryptoReceiveSelection();
                this.ensureCryptoPaySelection();
            },
            ensureCryptoReceiveSelection(preferredKey) {
                const items = this.cryptoAssetItems || [];

                if (!items.length) {
                    this.cryptoReceiveCurrency = '';
                    this.cryptoReceiveAssetKey = '';
                    return;
                }

                let selected = preferredKey ? items.find(item => item.value === preferredKey) : null;
                selected = selected || items.find(item => item.value === this.cryptoReceiveAssetKey) || null;

                if (!selected) {
                    const currency = this.cryptoReceiveCurrency && items.some(item => item.asset === this.cryptoReceiveCurrency)
                        ? this.cryptoReceiveCurrency
                        : items[0].asset;

                    selected = items.find(item => item.asset === currency) || items[0];
                }

                this.cryptoReceiveCurrency = selected.asset;
                this.cryptoReceiveAssetKey = selected.value;
            },
            selectFirstCryptoReceiveNetwork(asset) {
                const selected = (this.cryptoAssetItems || []).find(item => item.asset === asset);

                if (!selected) {
                    return;
                }

                this.cryptoReceiveCurrency = selected.asset;
                this.cryptoReceiveAssetKey = selected.value;
            },
            ensureCryptoPaySelection(preferredKey) {
                const items = this.cryptoAssetItems || [];

                if (!items.length) {
                    this.cryptoPayCurrency = '';
                    this.cryptoWithdrawalForm.asset_key = '';
                    return;
                }

                let selected = preferredKey ? items.find(item => item.value === preferredKey) : null;
                selected = selected || items.find(item => item.value === this.cryptoWithdrawalForm.asset_key) || null;

                if (!selected) {
                    const currency = this.cryptoPayCurrency && items.some(item => item.asset === this.cryptoPayCurrency)
                        ? this.cryptoPayCurrency
                        : items[0].asset;

                    selected = items.find(item => item.asset === currency) || items[0];
                }

                this.cryptoPayCurrency = selected.asset;
                this.cryptoWithdrawalForm.asset_key = selected.value;
            },
            onCryptoPayCurrencyChange(asset) {
                const selected = (this.cryptoAssetItems || []).find(item => item.asset === asset);

                if (!selected) {
                    this.cryptoPayCurrency = '';
                    this.cryptoWithdrawalForm.asset_key = '';
                    return;
                }

                this.cryptoPayCurrency = selected.asset;
                this.cryptoWithdrawalForm.asset_key = selected.value;
                this.scheduleCryptoWithdrawalPreview();
            },
            onCryptoPayNetworkChange(value) {
                this.ensureCryptoPaySelection(value || this.cryptoWithdrawalForm.asset_key);
                this.scheduleCryptoWithdrawalPreview();
            },
            cryptoAssetKey(item) {
                return (item.asset || '') + '|' + (item.network || '');
            },
            cryptoAssetSymbol(asset, source) {
                if (source && (source.symbol_native || source.symbol)) {
                    return source.symbol_native || source.symbol;
                }

                return moneyCurrencySymbol(this.currencySources(), asset);
            },
            cryptoAssetLogo(asset, source) {
                if (source && source.logo_url) {
                    return source.logo_url;
                }

                const item = (this.cryptoAssetItems || []).find(assetItem => assetItem.asset === asset && assetItem.logo_url);
                if (item) {
                    return item.logo_url;
                }

                return this.currencyLogo(asset);
            },
            cryptoAssetFromKey(value) {
                const parts = String(value || '').split('|');

                if (parts.length !== 2) {
                    return null;
                }

                return (this.crypto.assets || []).find(item => item.asset === parts[0] && item.network === parts[1]) || null;
            },
            cryptoAddressFor(asset) {
                if (!asset) {
                    return null;
                }

                return (this.crypto.addresses || []).find(item => item.asset === asset.asset && item.network === asset.network) || null;
            },
            shortAddress(value) {
                const text = String(value || '');

                if (text.length <= 18) {
                    return text;
                }

                return text.slice(0, 8) + '...' + text.slice(-8);
            },
            cryptoProviderLabel(provider) {
                const labels = {
                    circle: 'Circle',
                    tatum: 'Tatum',
                    trongrid: 'TronGrid',
                    bitgo: 'BitGo',
                    manual: 'Manual'
                };

                return labels[String(provider || '').toLowerCase()] || 'Manual';
            },
            applyCryptoWalletResponse(data) {
                if (data.dashboard) {
                    this.crypto = data.dashboard;
                } else if (data.address) {
                    const addresses = this.crypto.addresses || [];
                    const index = addresses.findIndex(item => item.asset === data.address.asset && item.network === data.address.network);

                    if (index >= 0) {
                        this.$set(addresses, index, data.address);
                    } else {
                        addresses.push(data.address);
                    }

                    this.$set(this.crypto, 'addresses', addresses);
                }

                if (data.balances) {
                    this.balances = data.balances;
                }

                this.setCryptoDefaults();
                this.setWalletCurrencyDefault();
            },
            openCryptoReceive(item) {
                this.ensureCryptoReceiveSelection(item.key || this.cryptoAssetKey(item));
                this.openWallet('receive');
            },
            onCryptoReceiveCurrencyChange(value) {
                if (value) {
                    this.selectFirstCryptoReceiveNetwork(value);
                }
            },
            onCryptoReceiveNetworkChange(value) {
                if (value) {
                    this.ensureCryptoReceiveSelection(value);
                }
            },
            previousWalletCard() {
                this.changeWalletCard(-1);
            },
            nextWalletCard() {
                this.changeWalletCard(1);
            },
            changeWalletCard(step) {
                const cards = this.balanceCards || [];

                if (cards.length <= 1) {
                    return;
                }

                const currentIndex = Math.max(0, cards.findIndex(card => card.currency === this.selectedWalletCurrency));
                const nextIndex = (currentIndex + step + cards.length) % cards.length;
                this.selectedWalletCurrency = cards[nextIndex].currency;
            },
            openCurrencyQr(card) {
                const active = card && card.activeNetworks && card.activeNetworks.length ? card.activeNetworks[0] : null;

                if (card && card.currency) {
                    this.selectedWalletCurrency = card.currency;
                }

                if (!active) {
                    this.openReceiveQrDialog();
                    return;
                }

                this.openReceiveQrDialog(active.key);
            },
            activateCurrencyWallet(card) {
                if (!card || !card.currency || !card.pendingNetworks || !card.pendingNetworks.length) {
                    this.$toast.info('Esta moneda no tiene redes pendientes por activar.', {icon: 'mdi-information'});
                    return;
                }

                this.activateCryptoWallet({
                    asset: card.currency,
                    key: card.currency
                });
            },
            activateCryptoWallet(item) {
                if (this.cryptoActivatingKey) {
                    return;
                }

                if (!item || !item.asset) {
                    this.$toast.warning('Selecciona la moneda que deseas activar.', {icon: 'mdi-alert-circle'});
                    return;
                }

                const payload = { asset: item.asset };

                if (item.network) {
                    payload.network = item.network;
                }

                this.cryptoActivatingKey = item.key || item.asset;
                axios.post('/api/wallet/crypto/activate', payload).then(res => {
                    if (res.data.v === 'warning') {
                        this.$toast.warning(res.data.status, {icon: 'mdi-alert-circle'});
                    } else {
                        this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    }
                    this.applyCryptoWalletResponse(res.data);
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible activar la billetera.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.cryptoActivatingKey = null;
                    this.setWalletCurrencyDefault();
                });
            },
            loadCryptoAddress() {
                const selected = this.selectedCryptoReceiveAsset;

                if (!selected || this.cryptoAddressLoading) {
                    return;
                }

                if (this.selectedCryptoAddress) {
                    return;
                }

                this.cryptoAddressLoading = true;
                axios.post('/api/wallet/crypto/address', {
                    asset: selected.asset,
                    network: selected.network
                }).then(res => {
                    this.applyCryptoWalletResponse(res.data);
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible generar la direccion.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.cryptoAddressLoading = false;
                });
            },
            setCurrencyDefaults() {
                this.rechargeForm.target_currency = this.selectDefaultCurrency(this.rechargeWalletCurrencies, this.rechargeForm.target_currency || this.walletCurrency);
                this.withdrawForm.source_currency = this.selectDefaultCurrency(this.withdrawSourceCurrencies, this.withdrawForm.source_currency || this.walletCurrency);
                this.rechargeForm.currency = this.selectDefaultCurrency(this.rechargeCurrencies, this.rechargeForm.currency);
                this.withdrawForm.currency = this.selectDefaultCurrency(this.withdrawCurrencies, this.withdrawForm.currency);
                this.payForm.currency = this.selectDefaultCurrency(this.payCurrencies, this.payForm.currency);
                this.requestForm.currency = this.selectDefaultCurrency(this.requestCurrencies, this.requestForm.currency);
                this.setRechargePaymentDefault();
                this.setDestinationDefaults();
            },
            setRechargePaymentDefault() {
                if (this.selectedRechargePaymentAccount) {
                    return;
                }

                this.rechargeForm.payment_account_id = this.rechargePaymentAccounts.length
                    ? this.rechargePaymentAccounts[0].id
                    : null;
            },
            goRechargeStep(step) {
                this.rechargeStep = Math.max(1, Math.min(3, Number(step || 1)));
            },
            onRechargeCurrencyChange() {
                this.rechargeForm.payment_account_id = null;
                this.setRechargePaymentDefault();
                this.onQuoteControlChange('recharge');
            },
            setDestinationDefaults() {
                const availableMethods = this.withdrawalMethods;

                if (!availableMethods.some(item => item.value === this.withdrawForm.payout_method)) {
                    this.withdrawForm.payout_method = availableMethods.length ? availableMethods[0].value : 'bank';
                }

                if (this.withdrawForm.payout_method === 'office') {
                    this.withdrawForm.customer_bank_account_id = null;
                    if (!this.withdrawForm.agent_office_id && this.agents.length > 0) {
                        this.withdrawForm.agent_office_id = this.agents[0].id;
                    }
                }

                if (this.withdrawForm.payout_method === 'bank') {
                    this.withdrawForm.agent_office_id = null;
                    if (!this.withdrawForm.customer_bank_account_id && this.bankAccounts.length > 0) {
                        this.withdrawForm.customer_bank_account_id = this.bankAccounts[0].id;
                    }
                }
            },
            selectDefaultCurrency(items, current) {
                if (current && this.currencyExists(items, current)) {
                    return current;
                }

                return items.length ? items[0].code : current;
            },
            currencyExists(items, code) {
                return items.some(item => (typeof item === 'string' ? item : item.code) === code);
            },
            fiatCurrencyItems(items) {
                const walletCodes = (this.walletCurrencyItems || []).map(item => String(item.code || '').toUpperCase());

                return (items || []).filter(item => {
                    const code = String((typeof item === 'string' ? item : item.code) || '').toUpperCase();

                    return walletCodes.indexOf(code) === -1;
                });
            },
            paymentCurrencyItems(items) {
                return (items || []).filter(item => !!String((typeof item === 'string' ? item : item.code) || '').trim());
            },
            currencyLabel(item) {
                if (typeof item === 'string') {
                    return item;
                }

                return item.label || (item.name ? item.code + ' - ' + item.name : item.code);
            },
            currencySources() {
                return []
                    .concat(this.currencies || [])
                    .concat(this.walletCurrencies || [])
                    .concat(this.quoteOptions.recharge || [])
                    .concat(this.quoteOptions.withdrawal || [])
                    .concat(this.quoteOptions.recharge_wallet_currencies || [])
                    .concat(this.quoteOptions.withdrawal_wallet_currencies || []);
            },
            currencyFieldConfig(code) {
                return moneyCurrencyFieldConfig(this.currencySources(), code);
            },
            currencyMeta(code) {
                return moneyCurrencyMeta(this.currencySources(), code);
            },
            currencyLogo(code) {
                const meta = this.currencyMeta(code);

                return meta && meta.logo_url ? meta.logo_url : '';
            },
            currencyDecimals(code) {
                return moneyCurrencyDecimals(this.currencySources(), code);
            },
            roundWalletAmount(code, value) {
                const decimals = this.currencyDecimals(code);
                const factor = Math.pow(10, decimals);

                return Math.round((Number(value || 0) + Number.EPSILON) * factor) / factor;
            },
            formatWalletAmount(code, value) {
                const currency = String(code || this.walletCurrency || 'USDC').toUpperCase();
                const symbol = moneyCurrencySymbol(this.currencySources(), currency);
                const decimals = this.currencyDecimals(currency);
                const amount = Number(value || 0).toLocaleString('es-CO', {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                });

                return symbol + ' ' + amount + ' ' + currency;
            },
            zeroBalanceText(code) {
                const currency = String(code || this.walletCurrency || 'USDC').toUpperCase();
                const symbol = moneyCurrencySymbol(this.currencySources(), currency);
                const decimals = this.currencyDecimals(currency);
                const amount = Number(0).toLocaleString('en-US', {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                });

                return symbol + ' ' + amount + ' ' + currency;
            },
            walletCurrencyPriority(code) {
                const order = ['USDC', 'EURC', 'USDT'];
                const index = order.indexOf(String(code || '').toUpperCase());

                return index === -1 ? 99 : index;
            },
            amountCurrency(type) {
                if (type === 'recharge') {
                    return this.rechargeForm.currency;
                }

                if (type === 'withdrawal') {
                    return this.withdrawSourceCurrency;
                }

                if (type === 'request') {
                    return this.requestForm.currency;
                }

                return this.payForm.currency;
            },
            amountForm(type) {
                if (type === 'recharge') {
                    return this.rechargeForm;
                }

                if (type === 'withdrawal') {
                    return this.withdrawForm;
                }

                if (type === 'request') {
                    return this.requestForm;
                }

                return this.payForm;
            },
            amountLimit(type, kind) {
                const limits = this.walletLimits || {};
                const limitType = type === 'request' ? 'pay' : type;
                const group = limits[limitType] || {};
                const key = kind === 'min' ? 'minimums' : 'maximums';
                const map = group[key] || {};
                const code = this.amountCurrency(type);

                if (limitType === 'recharge' && kind === 'min') {
                    return map[code] || (limits.recharge_minimums ? limits.recharge_minimums[code] : null) || null;
                }

                return map[code] || null;
            },
            amountLimitText(type) {
                const minimum = this.amountLimit(type, 'min');
                const maximum = this.amountLimit(type, 'max');

                if (minimum && maximum) {
                    return 'Monto permitido: ' + minimum.formatted + ' a ' + maximum.formatted + '.';
                }

                if (minimum) {
                    return 'Monto minimo: ' + minimum.formatted + '.';
                }

                if (maximum) {
                    return 'Monto maximo: ' + maximum.formatted + '.';
                }

                return '';
            },
            amountLimitRule(type) {
                return value => this.amountLimitError(type, value) || true;
            },
            amountLimitError(type, value) {
                const amount = this.walletAmountValue(value !== undefined ? value : this.amountForm(type).amount, this.amountCurrency(type));
                const minimum = this.amountLimit(type, 'min');
                const maximum = this.amountLimit(type, 'max');

                if (amount <= 0) {
                    return '';
                }

                if (minimum && amount + 0.0001 < Number(minimum.amount)) {
                    return 'El monto minimo es ' + minimum.formatted + '.';
                }

                if (maximum && amount - 0.0001 > Number(maximum.amount)) {
                    return 'El monto maximo es ' + maximum.formatted + '.';
                }

                return '';
            },
            amountWithinLimits(type) {
                return this.amountLimitError(type) === '';
            },
            onQuoteControlChange(type) {
                if (type === 'recharge') {
                    this.setRechargePaymentDefault();
                }
                this.scheduleQuote(type);
                this.refreshQuoteAmountValidation(type);
            },
            refreshPayAmountValidation() {
                this.$nextTick(() => {
                    const field = this.$refs.payAmountField;
                    if (!field || typeof field.resetValidation !== 'function' || typeof field.validate !== 'function') {
                        return;
                    }

                    const amount = this.walletAmountValue(this.payForm.amount, this.payForm.currency);
                    if (amount <= 0) {
                        field.resetValidation();
                        return;
                    }

                    field.validate(true);
                });
            },
            refreshRequestAmountValidation() {
                this.$nextTick(() => {
                    const field = this.$refs.requestAmountField;
                    if (!field || typeof field.resetValidation !== 'function' || typeof field.validate !== 'function') {
                        return;
                    }

                    const amount = this.walletAmountValue(this.requestForm.amount, this.requestForm.currency);
                    if (amount <= 0) {
                        field.resetValidation();
                        return;
                    }

                    field.validate(true);
                });
            },
            refreshQuoteAmountValidation(type) {
                const refName = type === 'recharge' ? 'rechargeAmountField' : 'withdrawAmountField';

                this.$nextTick(() => {
                    const field = this.$refs[refName];
                    if (!field || typeof field.resetValidation !== 'function' || typeof field.validate !== 'function') {
                        return;
                    }

                    const amount = this.walletAmountValue(this.quoteForm(type).amount, this.amountCurrency(type));
                    if (amount <= 0) {
                        field.resetValidation();
                        return;
                    }

                    field.validate(true);
                });
            },
            walletAmountValue(value, currencyCode) {
                return parseMoney(value, this.currencySources(), currencyCode);
            },
            scheduleCryptoWithdrawalPreview() {
                clearTimeout(this.cryptoWithdrawalPreviewTimer);
                this.cryptoWithdrawalPreview = null;

                if (this.walletMode !== 'transfer' || this.payDestination !== 'crypto') {
                    this.cryptoWithdrawalPreviewLoading = false;
                    return;
                }

                const selected = this.selectedCryptoWithdrawalAsset;
                if (!selected) {
                    this.cryptoWithdrawalPreviewLoading = false;
                    return;
                }

                const amount = this.walletAmountValue(this.cryptoWithdrawalForm.amount, selected.asset);
                if (amount <= 0) {
                    this.cryptoWithdrawalPreviewLoading = false;
                    return;
                }

                this.cryptoWithdrawalPreviewLoading = true;
                this.cryptoWithdrawalPreviewTimer = setTimeout(() => {
                    this.fetchCryptoWithdrawalPreview(selected, amount);
                }, 450);
            },
            fetchCryptoWithdrawalPreview(selected, amount) {
                axios.post('/api/wallet/crypto/withdrawal/preview', {
                    asset: selected.asset,
                    network: selected.network,
                    amount: amount
                }).then(res => {
                    const preview = res.data.preview || null;
                    const current = this.selectedCryptoWithdrawalAsset;
                    const currentAmount = current ? this.walletAmountValue(this.cryptoWithdrawalForm.amount, current.asset) : 0;

                    if (preview && current && preview.asset === current.asset && preview.network === current.network && Math.abs(Number(preview.amount || 0) - currentAmount) <= 0.00000001) {
                        this.cryptoWithdrawalPreview = preview;
                    }
                }).catch(() => {
                    this.cryptoWithdrawalPreview = null;
                }).then(() => {
                    this.cryptoWithdrawalPreviewLoading = false;
                });
            },
            cryptoWithdrawalBalanceRule() {
                const preview = this.cryptoWithdrawalFeePreview;
                const currency = this.cryptoWithdrawalCurrency;
                const balance = this.balanceMap[currency] ? Number(this.balanceMap[currency].amount || 0) : 0;

                if (!preview || preview.raw_total <= 0 || balance + 0.00000001 >= preview.raw_total) {
                    return true;
                }

                return 'Saldo insuficiente para cubrir monto y comisiones.';
            },
            scheduleQuote(type) {
                this.quoteErrors[type] = '';
                clearTimeout(this.quoteTimers[type]);

                if (!this.hasQuoteInput(type)) {
                    this.clearQuote(type);
                    return;
                }

                if (!this.amountWithinLimits(type)) {
                    this.clearQuote(type);
                    this.quoteErrors[type] = this.amountLimitError(type);
                    return;
                }

                this.quoteLoading[type] = true;
                this.quoteTimers[type] = setTimeout(() => {
                    this.fetchQuote(type);
                }, 350);
            },
            fetchQuote(type) {
                const form = this.quoteForm(type);
                const amount = this.walletAmountValue(form.amount, this.amountCurrency(type));
                const currency = form.currency;
                const walletCurrency = type === 'recharge' ? this.rechargeWalletCurrency : this.withdrawSourceCurrency;
                const quoteKey = this.quoteKey(type);

                this.quoteErrors[type] = '';

                if (!form.currency || !amount || amount <= 0) {
                    this.clearQuote(type);
                    return;
                }

                if (!this.amountWithinLimits(type)) {
                    this.clearQuote(type);
                    this.quoteErrors[type] = this.amountLimitError(type);
                    return;
                }

                this.quoteLoading[type] = true;

                const payload = {
                    currency: currency,
                    amount: amount
                };

                if (type === 'recharge') {
                    payload.target_currency = walletCurrency;
                } else {
                    payload.source_currency = walletCurrency;
                }

                axios.post('/api/wallet/quote/' + type, payload).then(res => {
                    if (form.currency !== currency || this.quoteWalletCurrency(type) !== walletCurrency || this.walletAmountValue(form.amount, this.amountCurrency(type)) !== amount) {
                        return;
                    }

                    this.setQuote(type, res.data.quote);
                }).catch(err => {
                    if (form.currency !== currency || this.quoteWalletCurrency(type) !== walletCurrency || this.walletAmountValue(form.amount, this.amountCurrency(type)) !== amount) {
                        return;
                    }

                    this[quoteKey] = null;
                    this.quoteLocalExpiresAt[type] = 0;
                    this.quoteCountdown[type] = 0;
                    this.quoteErrors[type] = this.errorMessage(err, 'No fue posible calcular la conversion.');
                }).then(() => {
                    if (form.currency === currency && this.quoteWalletCurrency(type) === walletCurrency && this.walletAmountValue(form.amount, this.amountCurrency(type)) === amount) {
                        this.quoteLoading[type] = false;
                    }
                });
            },
            quoteWalletCurrency(type) {
                return type === 'recharge' ? this.rechargeWalletCurrency : this.withdrawSourceCurrency;
            },
            quoteKey(type) {
                return type === 'recharge' ? 'rechargeQuote' : 'withdrawQuote';
            },
            quoteForm(type) {
                return type === 'recharge' ? this.rechargeForm : this.withdrawForm;
            },
            quoteFor(type) {
                return this[this.quoteKey(type)];
            },
            hasQuoteInput(type) {
                const form = this.quoteForm(type);
                const amount = this.walletAmountValue(form.amount, this.amountCurrency(type));

                return !!form.currency && !!this.quoteWalletCurrency(type) && amount > 0;
            },
            clearQuote(type) {
                this[this.quoteKey(type)] = null;
                this.quoteLoading[type] = false;
                this.quoteLocalExpiresAt[type] = 0;
                this.quoteCountdown[type] = 0;
            },
            setQuote(type, quote) {
                this[this.quoteKey(type)] = quote;
                this.quoteLocalExpiresAt[type] = Date.now() + (Number(quote && quote.ttl_seconds ? quote.ttl_seconds : 300) * 1000);
                this.quoteCountdown[type] = Number(quote && quote.ttl_seconds ? quote.ttl_seconds : 300);
                this.quoteAutoRefreshAt[type] = 0;
                this.tickQuotes();
            },
            tickQuotes() {
                ['recharge', 'withdrawal'].forEach(type => {
                    const quote = this.quoteFor(type);

                    if (!quote) {
                        this.quoteCountdown[type] = 0;
                        return;
                    }

                    const remaining = Math.max(0, Math.ceil((this.quoteLocalExpiresAt[type] - Date.now()) / 1000));
                    this.quoteCountdown[type] = remaining;

                    if (remaining > 0 || this.quoteLoading[type] || !this.hasQuoteInput(type)) {
                        return;
                    }

                    if (!this.walletDialog || (type === 'recharge' && this.walletMode !== 'recharge') || (type === 'withdrawal' && this.walletMode !== 'withdraw')) {
                        return;
                    }

                    if (Date.now() - this.quoteAutoRefreshAt[type] < 5000) {
                        return;
                    }

                    this.quoteAutoRefreshAt[type] = Date.now();
                    this.fetchQuote(type);
                });
            },
            quoteCountdownText(type) {
                const remaining = Math.max(0, this.quoteCountdown[type] || 0);
                const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
                const seconds = String(remaining % 60).padStart(2, '0');

                return minutes + ':' + seconds;
            },
            quoteMatches(type) {
                const quote = this.quoteFor(type);
                const form = this.quoteForm(type);
                const amount = this.walletAmountValue(form.amount, this.amountCurrency(type));

                if (!quote || !form.currency || !amount || amount <= 0) {
                    return false;
                }

                if (quote.flow !== type || Math.abs(Number(quote.source_amount) - amount) > 0.0001) {
                    return false;
                }

                if (type === 'recharge') {
                    return quote.source_currency === form.currency && quote.target_currency === this.rechargeWalletCurrency;
                }

                return quote.source_currency === this.withdrawSourceCurrency && quote.target_currency === form.currency;
            },
            canSubmitQuote(type) {
                if (!this.amountWithinLimits(type)) {
                    return false;
                }

                return this.quoteMatches(type) && !this.quoteLoading[type] && this.quoteCountdown[type] > 0;
            },
            feeText(quote, side) {
                const fee = quote && quote.fees ? quote.fees[side] : null;

                if (!fee || !fee.has_fee) {
                    return 'Sin comision';
                }

                return fee.formatted;
            },
            transactionStatusColor(item) {
                const status = item.status;

                if (status === 'completed' || status === 'approved' || status === 203 || status === 254) {
                    return 'success';
                }

                if (status === 'pending' || status === 201 || status === 251) {
                    return 'warning';
                }

                if (status === 'rejected' || status === 'failed' || status === 204 || status === 205 || status === 206 || status === 255) {
                    return 'error';
                }

                if (status === 253) {
                    return 'tertiary';
                }

                return 'info';
            },
            submitRecharge() {
                if (!this.$refs.rechargeForm || !this.$refs.rechargeForm.validate()) return;
                if (!this.canSubmitQuote('recharge')) {
                    this.scheduleQuote('recharge');
                    this.$toast.warning('Actualiza la conversion antes de enviar la recarga.', {icon: 'mdi-timer-alert'});
                    return;
                }
                if (!this.rechargeDestinationReady) {
                    this.$toast.warning('Selecciona la cuenta donde realizaste el pago.', {icon: 'mdi-bank-alert'});
                    return;
                }

                this.walletLoading = true;

                const data = new FormData();
                data.append('currency', this.rechargeForm.currency);
                data.append('target_currency', this.rechargeWalletCurrency);
                data.append('amount', this.walletAmountValue(this.rechargeForm.amount, this.rechargeForm.currency));
                data.append('voucher', this.rechargeForm.voucher);
                data.append('quote', JSON.stringify(this.rechargeQuote));
                data.append('payment_account_id', this.rechargeForm.payment_account_id);

                axios.post('/api/wallet/recharge', data).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    this.resetRechargeForm();
                    this.closeWallet();
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible enviar la recarga.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.walletLoading = false;
                });
            },
            lookupRecipient() {
                this.recipient = null;
                this.payForm.nickname = this.cleanNickname(this.payForm.nickname);
                if (!this.payForm.nickname) return;

                this.recipientLoading = true;
                axios.post('/api/wallet/recipient', {nickname: this.payForm.nickname}).then(res => {
                    this.recipient = res.data.recipient;
                    this.payForm.save_contact = !this.recipientIsWalletContact && this.payForm.save_contact;
                }).catch(() => {
                    this.recipient = null;
                }).then(() => {
                    this.recipientLoading = false;
                });
            },
            lookupRequestRecipient() {
                this.requestRecipient = null;
                this.requestForm.nickname = this.cleanNickname(this.requestForm.nickname);
                if (!this.requestForm.nickname) return;

                this.requestRecipientLoading = true;
                axios.post('/api/wallet/recipient', {nickname: this.requestForm.nickname}).then(res => {
                    this.requestRecipient = res.data.recipient;
                }).catch(() => {
                    this.requestRecipient = null;
                }).then(() => {
                    this.requestRecipientLoading = false;
                });
            },
            selectWalletContact(nickname) {
                if (!nickname) {
                    return;
                }

                this.payForm.nickname = this.cleanNickname(nickname);
                this.payForm.save_contact = false;
                this.lookupRecipient();
            },
            selectRequestWalletContact(nickname) {
                if (!nickname) {
                    return;
                }

                this.requestForm.nickname = this.cleanNickname(nickname);
                this.lookupRequestRecipient();
            },
            saveRecipientContact() {
                const nickname = this.recipient ? this.recipient.nickname : this.payForm.nickname;

                if (!nickname || this.contactSaving) {
                    return;
                }

                this.contactSaving = true;
                axios.post('/api/wallet/contacts', {
                    nickname: nickname,
                    alias: this.recipient ? this.recipient.name : null,
                    is_favorite: true
                }).then(res => {
                    this.mergeWalletContact(res.data.contact);
                    this.payForm.save_contact = false;
                    this.$toast.success(res.data.status, {icon: 'mdi-star-check'});
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible guardar el favorito.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.contactSaving = false;
                });
            },
            mergeWalletContact(contact) {
                if (!contact) {
                    return;
                }

                const nickname = this.cleanNickname(contact.nickname);
                const index = (this.walletContacts || []).findIndex(item => this.cleanNickname(item.nickname) === nickname);

                if (index >= 0) {
                    this.$set(this.walletContacts, index, contact);
                } else {
                    this.walletContacts.unshift(contact);
                }

                this.selectedWalletContactNickname = contact.raw_nickname || nickname;
                this.selectedRequestWalletContactNickname = contact.raw_nickname || nickname;
            },
            async submitPay() {
                if (!this.$refs.payForm || !this.$refs.payForm.validate()) return;
                if (!this.amountWithinLimits('pay')) {
                    this.refreshPayAmountValidation();
                    this.$toast.warning(this.amountLimitError('pay'), {icon: 'mdi-alert-circle'});
                    return;
                }

                this.payForm.nickname = this.cleanNickname(this.payForm.nickname);
                let securityPayload;
                try {
                    securityPayload = await this.sensitivePayload('Confirma el pago', 'wallet_pay');
                } catch (error) {
                    return;
                }

                this.walletLoading = true;
                axios.post('/api/wallet/pay', Object.assign({}, this.payForm, securityPayload, {
                    amount: this.walletAmountValue(this.payForm.amount, this.payForm.currency),
                    save_contact: this.payForm.save_contact && !this.recipientIsWalletContact,
                    contact_alias: this.recipient ? this.recipient.name : null
                })).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    this.mergeWalletContact(res.data.contact);
                    if (res.data.contact_warning) {
                        this.$toast.warning(res.data.contact_warning, {icon: 'mdi-information'});
                    }
                    this.resetPayForm();
                    this.closeWallet();
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible realizar la transferencia.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.walletLoading = false;
                });
            },
            submitPaymentRequest() {
                if (!this.$refs.requestPaymentForm || !this.$refs.requestPaymentForm.validate()) return;
                if (!this.amountWithinLimits('request')) {
                    this.refreshRequestAmountValidation();
                    this.$toast.warning(this.amountLimitError('request'), {icon: 'mdi-alert-circle'});
                    return;
                }

                this.requestForm.nickname = this.cleanNickname(this.requestForm.nickname);
                this.walletLoading = true;
                axios.post('/api/wallet/payment-requests', Object.assign({}, this.requestForm, {
                    amount: this.walletAmountValue(this.requestForm.amount, this.requestForm.currency)
                })).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    this.paymentRequests = res.data.payment_requests || this.paymentRequests;
                    this.resetRequestPaymentForm();
                    this.closeWallet();
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible enviar la solicitud.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.walletLoading = false;
                });
            },
            async approvePaymentRequest(item) {
                if (!item || !item.id || this.paymentRequestLoadingId) {
                    return;
                }

                let securityPayload;
                try {
                    securityPayload = await this.sensitivePayload('Confirma el pago solicitado', 'wallet_payment_request_approve');
                } catch (error) {
                    return;
                }

                this.paymentRequestLoadingId = 'approve-' + item.id;
                axios.post('/api/wallet/payment-requests/' + item.id + '/approve', securityPayload).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    if (res.data.result && res.data.result.payment_requests) {
                        this.paymentRequests = res.data.result.payment_requests;
                    }
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible aprobar el pago.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.paymentRequestLoadingId = null;
                });
            },
            rejectPaymentRequest(item) {
                if (!item || !item.id || this.paymentRequestLoadingId) {
                    return;
                }

                this.paymentRequestLoadingId = 'reject-' + item.id;
                axios.post('/api/wallet/payment-requests/' + item.id + '/reject').then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    if (res.data.result && res.data.result.payment_requests) {
                        this.paymentRequests = res.data.result.payment_requests;
                    }
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible rechazar la solicitud.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.paymentRequestLoadingId = null;
                });
            },
            withdrawalDestinationReady() {
                if (this.withdrawForm.payout_method === 'office') {
                    return !!this.withdrawForm.agent_office_id && this.agents.length > 0;
                }

                if (this.withdrawForm.payout_method === 'bank') {
                    return !!this.withdrawForm.customer_bank_account_id && this.bankAccounts.length > 0;
                }

                return false;
            },
            async requestLocation() {
                if (!navigator.geolocation || this.locationLoading || !this.agents.length) {
                    return;
                }

                const permissionState = await queryBrowserPermission('geolocation', 'geolocation');
                this.locationPermissionState = permissionState;

                if (permissionState === 'denied') {
                    return;
                }

                this.locationLoading = true;
                navigator.geolocation.getCurrentPosition(position => {
                    this.userLocation = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    };
                    rememberPermissionState('geolocation', 'granted');
                    this.locationPermissionState = 'granted';
                    this.locationLoading = false;
                }, error => {
                    if (error && error.code === 1) {
                        rememberPermissionState('geolocation', 'denied');
                        this.locationPermissionState = 'denied';
                    }
                    this.locationLoading = false;
                }, {
                    enableHighAccuracy: false,
                    timeout: 7000,
                    maximumAge: 300000
                });
            },
            agentDistance(agent) {
                if (!this.userLocation || !agent.latitude || !agent.longitude) {
                    return null;
                }

                const lat1 = this.toRadians(Number(this.userLocation.latitude));
                const lon1 = this.toRadians(Number(this.userLocation.longitude));
                const lat2 = this.toRadians(Number(agent.latitude));
                const lon2 = this.toRadians(Number(agent.longitude));

                if ([lat1, lon1, lat2, lon2].some(value => isNaN(value))) {
                    return null;
                }

                const dLat = lat2 - lat1;
                const dLon = lon2 - lon1;
                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
                    + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                return Math.round(6371 * c * 10) / 10;
            },
            toRadians(value) {
                return value * Math.PI / 180;
            },
            formatDistance(distance) {
                return Number(distance).toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + ' km';
            },
            agentMapUrl(agent) {
                const lat = Number(agent && agent.latitude);
                const lng = Number(agent && agent.longitude);

                if (isNaN(lat) || isNaN(lng)) {
                    return '';
                }

                const delta = 0.01;
                const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(',');

                return 'https://www.openstreetmap.org/export/embed.html?bbox=' + encodeURIComponent(bbox) + '&marker=' + encodeURIComponent(lat + ',' + lng);
            },
            agentMapLink(agent) {
                if (agent && agent.gmaps) {
                    return 'https://maps.app.goo.gl/' + agent.gmaps;
                }

                if (agent && agent.latitude && agent.longitude) {
                    return 'https://www.openstreetmap.org/?mlat=' + agent.latitude + '&mlon=' + agent.longitude + '#map=16/' + agent.latitude + '/' + agent.longitude;
                }

                return '#';
            },
            async submitWithdrawal() {
                if (!this.$refs.withdrawForm || !this.$refs.withdrawForm.validate()) return;
                if (!this.canSubmitQuote('withdrawal')) {
                    this.scheduleQuote('withdrawal');
                    this.$toast.warning('Actualiza la conversion antes de solicitar el retiro.', {icon: 'mdi-timer-alert'});
                    return;
                }
                if (!this.withdrawalDestinationReady()) {
                    this.$toast.warning('Selecciona un destino de retiro disponible.', {icon: 'mdi-alert-circle'});
                    return;
                }

                let securityPayload;
                try {
                    securityPayload = await this.sensitivePayload('Confirma el retiro', 'wallet_withdrawal');
                } catch (error) {
                    return;
                }

                this.walletLoading = true;
                axios.post('/api/wallet/withdrawal', Object.assign({
                    currency: this.withdrawForm.currency,
                    source_currency: this.withdrawSourceCurrency,
                    amount: this.walletAmountValue(this.withdrawForm.amount, this.withdrawSourceCurrency),
                    payout_method: this.withdrawForm.payout_method,
                    agent_office_id: this.withdrawForm.agent_office_id,
                    customer_bank_account_id: this.withdrawForm.customer_bank_account_id,
                    note: this.withdrawForm.note,
                    quote: this.withdrawQuote
                }, securityPayload)).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    this.resetWithdrawForm();
                    this.closeWallet();
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible solicitar el retiro.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.walletLoading = false;
                });
            },
            async submitCryptoWithdrawal() {
                if (!this.$refs.cryptoPayForm || !this.$refs.cryptoPayForm.validate()) return;

                const selected = this.selectedCryptoWithdrawalAsset;
                if (!selected) {
                    this.$toast.warning('Selecciona el activo y la red.', {icon: 'mdi-alert-circle'});
                    return;
                }

                let securityPayload;
                try {
                    securityPayload = await this.sensitivePayload('Confirma el envio cripto', 'wallet_crypto_withdrawal');
                } catch (error) {
                    return;
                }

                this.walletLoading = true;
                axios.post('/api/wallet/crypto/withdrawal', Object.assign({
                    asset: selected.asset,
                    network: selected.network,
                    amount: this.walletAmountValue(this.cryptoWithdrawalForm.amount, selected.asset),
                    destination_address: this.cryptoWithdrawalForm.destination_address,
                    destination_tag: this.cryptoWithdrawalForm.destination_tag,
                    note: this.cryptoWithdrawalForm.note
                }, securityPayload)).then(res => {
                    this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    this.resetCryptoWithdrawalForm();
                    this.closeWallet();
                    this.getData();
                }).catch(err => {
                    this.$toast.error(this.errorMessage(err, 'No fue posible realizar el pago cripto.'), {icon: 'mdi-alert-circle'});
                }).then(() => {
                    this.walletLoading = false;
                });
            },
            onQrDecode(value) {
                const nickname = this.parseNicknameFromQr(value);

                if (!nickname) {
                    this.$toast.warning('El QR no contiene un nickname valido de Valzum.', {icon: 'mdi-qrcode-remove'});
                    return;
                }

                this.payForm.nickname = nickname;
                this.continueScannedPayment();
                this.$toast.success('QR leído correctamente. Revisa los datos antes de transferir.', {icon: 'mdi-qrcode-scan'});
            },
            onQrInit(promise) {
                promise.then(result => {
                    this.scanError = '';
                    this.$nextTick(() => {
                        this.prepareScannerTrackControls(result && result.capabilities ? result.capabilities : {});
                    });
                }).catch(error => {
                    this.scanError = this.cameraErrorMessage(error);
                    this.stopScanner();
                });
            },
            continueScannedPayment() {
                if (!this.payForm.nickname) return;

                this.walletMode = 'transfer';
                this.payDestination = 'valzum';
                this.stopScanner();
                this.$nextTick(() => {
                    this.lookupRecipient();
                });
            },
            parseNicknameFromQr(value) {
                const text = String(value || '').trim();
                if (!text) return '';

                try {
                    const url = new URL(text);
                    const param = url.searchParams.get('nickname') || url.searchParams.get('nick') || url.searchParams.get('to');
                    if (param) {
                        return this.cleanNickname(param);
                    }
                } catch (e) {}

                const match = text.match(/\$[A-Za-z0-9_.-]+/);
                if (match) {
                    return this.cleanNickname(match[0]);
                }

                return this.cleanNickname(text);
            },
            cleanNickname(value) {
                return String(value || '').trim().replace(/^\$/, '').toUpperCase();
            },
            resetRechargeForm() {
                this.rechargeForm.amount = null;
                this.rechargeForm.voucher = null;
                this.rechargeStep = 1;
                this.setRechargePaymentDefault();
                this.clearQuote('recharge');
                this.quoteErrors.recharge = '';
            },
            resetPayForm() {
                this.payForm.nickname = '';
                this.payForm.amount = null;
                this.payForm.note = '';
                this.payForm.save_contact = false;
                this.selectedWalletContactNickname = null;
                this.recipient = null;
            },
            resetRequestPaymentForm() {
                this.requestForm.nickname = '';
                this.requestForm.amount = null;
                this.requestForm.note = '';
                this.selectedRequestWalletContactNickname = null;
                this.requestRecipient = null;
            },
            resetWithdrawForm() {
                this.withdrawForm.amount = null;
                this.withdrawForm.payout_method = this.agents.length > 0 ? 'office' : 'bank';
                this.withdrawForm.agent_office_id = null;
                this.withdrawForm.customer_bank_account_id = null;
                this.withdrawForm.note = '';
                this.setDestinationDefaults();
                this.clearQuote('withdrawal');
                this.quoteErrors.withdrawal = '';
            },
            resetCryptoWithdrawalForm() {
                clearTimeout(this.cryptoWithdrawalPreviewTimer);
                this.cryptoWithdrawalPreview = null;
                this.cryptoWithdrawalPreviewLoading = false;
                this.cryptoWithdrawalForm.amount = null;
                this.cryptoWithdrawalForm.destination_address = '';
                this.cryptoWithdrawalForm.destination_tag = '';
                this.cryptoWithdrawalForm.note = '';
                this.setCryptoDefaults();
            },
            cameraErrorMessage(error) {
                if (!error || !error.name) {
                    return 'No fue posible activar la camara.';
                }

                if (['NotAllowedError', 'PermissionDeniedError', 'SecurityError'].indexOf(error.name) !== -1) {
                    return 'Debes permitir el acceso a la camara para leer el QR.';
                }
                if (error.name === 'NotFoundError') {
                    return 'No se encontro una camara disponible.';
                }
                if (error.name === 'NotSupportedError') {
                    return 'La camara solo funciona en HTTPS o localhost.';
                }
                if (error.name === 'NotReadableError') {
                    return 'La camara esta siendo usada por otra aplicacion.';
                }

                return 'No fue posible activar la camara.';
            },
            errorMessage(err, fallback) {
                if (err.response && err.response.data && err.response.data.status) {
                    return err.response.data.status;
                }

                const errors = err.response && err.response.data ? err.response.data.errors : null;
                const firstError = this.firstValidationError(errors);
                if (firstError) {
                    return firstError;
                }

                if (err.response && err.response.data && err.response.data.message) {
                    return err.response.data.message;
                }

                return fallback;
            },
            firstValidationError(errors) {
                if (!errors) {
                    return '';
                }

                const keys = Object.keys(errors);
                for (let i = 0; i < keys.length; i += 1) {
                    const messages = errors[keys[i]];
                    if (Array.isArray(messages) && messages.length) {
                        return messages[0];
                    }

                    if (typeof messages === 'string' && messages) {
                        return messages;
                    }
                }

                return '';
            },
            reloadAfterSessionConfirmation() {
                this.show = true;
                if (this.user && this.user.role === 'Administrator') {
                    this.adminShow = true;
                }
                this.getData(1);
                this.getDynamicKey();
            },
            getData(v) {
                clearTimeout(this.timeout);
                if (v === 1) {
                    this.loading = true;
                }
                axios.get('/api/home').then((res) => {
                    this.movements = res.data.transfers || [];
                    this.transactions = res.data.transactions || [];
                    this.balances = res.data.balances || [];
                    this.walletCurrency = res.data.wallet_currency || this.walletCurrency;
                    this.walletCurrencies = res.data.wallet_currencies || this.walletCurrencies;
                    this.crypto = res.data.crypto || this.crypto;
                    this.walletContacts = res.data.wallet_contacts || this.walletContacts;
                    this.paymentRequests = res.data.payment_requests || this.paymentRequests;
                    this.rates = res.data.rates;
                    this.setCryptoDefaults();
                    this.setWalletCurrencyDefault();
                    this.show = false;
                    if (this.user.role === 'Customer' && this.user.status === 101) {
                        this.idValidator = true;
                        this.idAdvance = 0;
                        const y = 100/12;
                        if (this.$props.user.photo !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.front !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.post !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.td !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.nd !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.name !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.email !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.birthday !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.expiration !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.citizenship !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.phone !== null)
                            this.idAdvance = this.idAdvance + y;
                        if (this.$props.user.country !== null)
                            this.idAdvance = this.idAdvance + y;
                    }
                    if (this.$props.user.role === 'Administrator') {
                        return axios.get('/api/admin/home').then((res) => {
                            const countries = this.countries;
                            const a = res.data.users;
                            const c = res.data.payments;
                            const d = res.data.transfers;

                            let users = [];
                            for (let i = 0; i < countries.length; i++) {
                                let n = 0;
                                for (let e = 0; e < a.length; e++) {
                                    if (countries[i].code === a[e].code) {
                                        n = a[e].total;
                                    }
                                }
                                users.push({
                                    code: countries[i].code,
                                    name: countries[i].name,
                                    total: n
                                })
                            }

                            let payments = [];
                            for (let i = 0; i < countries.length; i++) {
                                let n = 0;
                                for (let e = 0; e < c.length; e++) {
                                    if (countries[i].code === c[e].code) {
                                        n = c[e].total;
                                    }
                                }
                                payments.push({
                                    code: countries[i].code,
                                    name: countries[i].name,
                                    total: n
                                })
                            }

                            let transfers = [];
                            for (let i = 0; i < countries.length; i++) {
                                let n = 0;
                                for (let e = 0; e < d.length; e++) {
                                    if (countries[i].code === d[e].code) {
                                        n = d[e].total;
                                    }
                                }
                                transfers.push({
                                    code: countries[i].code,
                                    name: countries[i].name,
                                    total: n
                                })
                            }

                            this.users = users;
                            this.payments = payments;
                            this.transfers = transfers;
                            this.nUsers = res.data.nUsers;
                            this.nUsersCi = res.data.nUsersCi;
                            this.nPayments = res.data.nPayments;
                            this.nTransfers = res.data.nTransfers;
                            this.nComplete = res.data.nComplete;
                            this.nTickets = res.data.nTickets;
                            this.nOnlineCustomers = res.data.nOnlineCustomers || 0;
                            this.adminShow = false;
                        }).catch(err => {
                            this.adminShow = false;
                            this.$toast.error(this.errorMessage(err, 'No fue posible cargar el resumen administrativo.'), {icon: 'mdi-alert-circle'});
                        });
                    }
                }).catch(err => {
                    const errors = err.response && err.response.data ? err.response.data.errors : null;
                    if (errors) {
                        this.handleErrors(errors);
                    } else {
                        this.$toast.error(this.errorMessage(err, 'No fue posible cargar el inicio.'), {icon: 'mdi-alert-circle'});
                    }
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getData, 300000);
            },
            onCopy() {
                this.$toast.success('Se copió en el portapapeles.', {icon: 'mdi-content-copy'});
            },
            onError() {
                this.$toast.error('No se copió en el portapapeles.', {icon: 'mdi-content-copy'});
            },
            copyDynamicKey(value) {
                if (!value) return;

                this.copyToClipboard(String(value));
            },
            copyToClipboard(value) {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(value).then(() => {
                        this.$toast.success('Clave copiada.', {icon: 'mdi-content-copy'});
                    }).catch(() => {
                        this.copyToClipboardFallback(value);
                    });
                    return;
                }

                this.copyToClipboardFallback(value);
            },
            copyToClipboardFallback(value) {
                const input = document.createElement('textarea');
                input.value = value;
                input.setAttribute('readonly', 'readonly');
                input.style.position = 'fixed';
                input.style.opacity = '0';
                document.body.appendChild(input);
                input.select();

                try {
                    document.execCommand('copy');
                    this.$toast.success('Clave copiada.', {icon: 'mdi-content-copy'});
                } catch (error) {
                    this.$toast.error('No se pudo copiar.', {icon: 'mdi-alert-circle'});
                } finally {
                    document.body.removeChild(input);
                }
            },
            async downloadReceiveQr() {
                try {
                    const primary = '#0D93A5';
                    const secondary = '#DFF1F7';
                    const dark = '#12343B';
                    const canvas = document.createElement('canvas');
                    const width = 1200;
                    const height = 1600;
                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.fillStyle = '#FFFFFF';
                    ctx.fillRect(0, 0, width, height);

                    ctx.fillStyle = primary;
                    this.drawRoundRect(ctx, 80, 80, width - 160, height - 160, 42);

                    ctx.fillStyle = '#FFFFFF';
                    this.drawRoundRect(ctx, 130, 290, width - 260, 900, 36);

                    ctx.textAlign = 'center';
                    ctx.fillStyle = secondary;
                    ctx.font = '700 76px Arial';
                    ctx.fillText('VALZUM', width / 2, 205);
                    ctx.font = '500 34px Arial';
                    ctx.fillText('Wallet para pagos y remesas', width / 2, 255);

                    ctx.fillStyle = primary;
                    ctx.font = '700 68px Arial';
                    ctx.fillText('Escanea y paga', width / 2, 395);
                    ctx.fillStyle = dark;
                    ctx.font = '400 36px Arial';
                    ctx.fillText('Paga directo con Valzum', width / 2, 455);

                    const qrCanvas = document.createElement('canvas');
                    await QRCode.toCanvas(qrCanvas, this.qrValue, {
                        width: 700,
                        margin: 2,
                        color: {
                            dark: primary,
                            light: '#FFFFFF'
                        }
                    });

                    const qrX = (width - qrCanvas.width) / 2;
                    ctx.drawImage(qrCanvas, qrX, 520);
                    await this.drawQrCenterImage(ctx, '/img/favicon.png', width / 2, 520 + (qrCanvas.height / 2), 128);

                    ctx.fillStyle = primary;
                    ctx.font = '700 74px Arial';
                    ctx.fillText(this.accountTag, width / 2, 1285);

                    ctx.fillStyle = secondary;
                    this.drawRoundRect(ctx, 240, 1380, width - 480, 82, 41);
                    ctx.fillStyle = primary;
                    ctx.font = '700 34px Arial';
                    ctx.fillText('valzum.com', width / 2, 1434);

                    const link = document.createElement('a');
                    link.download = 'valzum-' + this.receiveNickname.toLowerCase() + '-qr.png';
                    link.href = canvas.toDataURL('image/png');
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    this.$toast.error('No fue posible descargar el QR.', {icon: 'mdi-alert-circle'});
                }
            },
            async downloadCryptoQr() {
                if (!this.selectedCryptoAddress) {
                    this.$toast.warning('Primero genera o selecciona una direccion crypto.', {icon: 'mdi-alert-circle'});
                    return;
                }

                try {
                    const primary = '#0D93A5';
                    const secondary = '#DFF1F7';
                    const dark = '#12343B';
                    const address = this.selectedCryptoAddress;
                    const canvas = document.createElement('canvas');
                    const width = 1200;
                    const height = 1600;
                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.fillStyle = '#FFFFFF';
                    ctx.fillRect(0, 0, width, height);

                    ctx.fillStyle = primary;
                    this.drawRoundRect(ctx, 80, 80, width - 160, height - 160, 42);

                    ctx.fillStyle = '#FFFFFF';
                    this.drawRoundRect(ctx, 130, 290, width - 260, 900, 36);

                    ctx.textAlign = 'center';
                    ctx.fillStyle = secondary;
                    ctx.font = '700 76px Arial';
                    ctx.fillText('VALZUM', width / 2, 205);
                    ctx.font = '500 34px Arial';
                    ctx.fillText('Deposito de wallet digital', width / 2, 255);

                    ctx.fillStyle = primary;
                    ctx.font = '700 78px Arial';
                    ctx.fillText(address.asset, width / 2, 385);
                    ctx.fillStyle = dark;
                    ctx.font = '700 40px Arial';
                    ctx.fillText('Red ' + address.network_label, width / 2, 445);

                    const qrCanvas = document.createElement('canvas');
                    await QRCode.toCanvas(qrCanvas, address.qr_value, {
                        width: 700,
                        margin: 2,
                        color: {
                            dark: primary,
                            light: '#FFFFFF'
                        }
                    });

                    const qrX = (width - qrCanvas.width) / 2;
                    ctx.drawImage(qrCanvas, qrX, 520);
                    const logoUrl = this.cryptoAssetLogo(address.asset, address);

                    if (logoUrl) {
                        await this.drawQrCenterImage(ctx, logoUrl, width / 2, 520 + (qrCanvas.height / 2), 128);
                    } else {
                        this.drawQrCenterSymbol(ctx, this.cryptoAssetSymbol(address.asset, address), width / 2, 520 + (qrCanvas.height / 2), 128, primary);
                    }

                    ctx.fillStyle = dark;
                    ctx.font = '700 32px Arial';
                    ctx.fillText('Direccion', width / 2, 1235);

                    ctx.font = '400 28px Arial';
                    this.drawWrappedText(ctx, address.address, width / 2, 1285, 880, 38);

                    if (address.tag) {
                        ctx.font = '700 30px Arial';
                        ctx.fillText('Tag/Memo: ' + address.tag, width / 2, 1390);
                    }

                    const link = document.createElement('a');
                    link.download = 'valzum-' + address.asset.toLowerCase() + '-' + String(address.network || '').toLowerCase() + '-qr.png';
                    link.href = canvas.toDataURL('image/png');
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    this.$toast.error('No fue posible descargar el QR crypto.', {icon: 'mdi-alert-circle'});
                }
            },
            drawWrappedText(ctx, text, x, y, maxWidth, lineHeight) {
                const value = String(text || '');
                let line = '';
                let lineY = y;

                for (let i = 0; i < value.length; i += 1) {
                    const next = line + value[i];
                    if (ctx.measureText(next).width > maxWidth && line !== '') {
                        ctx.fillText(line, x, lineY);
                        line = value[i];
                        lineY += lineHeight;
                    } else {
                        line = next;
                    }
                }

                if (line) {
                    ctx.fillText(line, x, lineY);
                }
            },
            loadImage(src) {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                    image.crossOrigin = 'anonymous';
                    image.onload = () => resolve(image);
                    image.onerror = reject;
                    image.src = src;
                });
            },
            async drawQrCenterImage(ctx, src, x, y, size) {
                try {
                    const image = await this.loadImage(src);
                    ctx.fillStyle = '#FFFFFF';
                    this.drawRoundRect(ctx, x - (size / 2), y - (size / 2), size, size, size / 2);
                    ctx.drawImage(image, x - (size * 0.34), y - (size * 0.34), size * 0.68, size * 0.68);
                } catch (error) {
                    // El QR sigue siendo valido aunque no cargue el logo.
                }
            },
            drawQrCenterSymbol(ctx, symbol, x, y, size, color) {
                ctx.fillStyle = '#FFFFFF';
                this.drawRoundRect(ctx, x - (size / 2), y - (size / 2), size, size, size / 2);
                ctx.fillStyle = color;
                ctx.font = '900 64px Arial';
                ctx.textAlign = 'center';
                ctx.fillText(String(symbol || '').slice(0, 3), x, y + 22);
            },
            drawRoundRect(ctx, x, y, width, height, radius) {
                const r = Math.min(radius, width / 2, height / 2);

                ctx.beginPath();
                ctx.moveTo(x + r, y);
                ctx.arcTo(x + width, y, x + width, y + height, r);
                ctx.arcTo(x + width, y + height, x, y + height, r);
                ctx.arcTo(x, y + height, x, y, r);
                ctx.arcTo(x, y, x + width, y, r);
                ctx.closePath();
                ctx.fill();
            },
            getReport(status) {
                let formData = new FormData();

                formData.append('key',  'attendance');
                formData.append('status',  status);
                formData.append('date',  new Date());

                axios.post('/api/staff/attendance', formData).then(res => {
                    if (res.data.v === 'success') {
                        if (res.data.result === 'open') {
                            this.activity.status = true;
                            this.activity.date = res.data.open;
                        } else {
                            this.activity.status = false;
                        }
                        this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                    } else {
                        this.$toast.error(res.data.status, {icon: 'mdi-information'});
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.report = false;
                });
            }
        },
        destroyed() {
            window.removeEventListener('valzum-session-confirmed', this.reloadAfterSessionConfirmation);
            clearTimeout(this.timeout);
            clearTimeout(this.quoteTimers.recharge);
            clearTimeout(this.quoteTimers.withdrawal);
            clearTimeout(this.cryptoWithdrawalPreviewTimer);
            clearInterval(this.timer);
            this.restoreScannerMediaOverrides();
        }
    }
</script>

<style scoped>
.trunck-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.wallet-hero {
    overflow: hidden;
}
.wallet-hero-content {
    position: relative;
}
.wallet-hero-header {
    margin: 0 auto;
    max-width: 860px;
    min-height: 68px;
    padding: 0 82px;
    position: relative;
}
.wallet-hero-qr-btn {
    align-items: center;
    display: inline-flex;
    height: 64px !important;
    justify-content: center;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 64px !important;
}
.wallet-hero-qr-btn ::v-deep .v-btn__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
}
.wallet-balance-carousel {
    align-items: center;
    display: flex;
    gap: 8px;
    max-width: 860px;
}
.wallet-balance-window {
    flex: 1 1 auto;
    min-width: 0;
}
.wallet-balance-arrow {
    flex: 0 0 auto;
}
.wallet-balance-main {
    max-width: 720px;
    padding-left: 4px;
    padding-right: 4px;
}
.wallet-carousel-dots .v-btn {
    opacity: .45;
}
.wallet-carousel-dot-active {
    opacity: 1 !important;
}
.wallet-dynamic-key {
    max-width: 280px;
    min-width: 0;
    width: auto;
    border: 1px solid rgba(255, 255, 255, .22);
    border-radius: 8px;
    background: rgba(255, 255, 255, .09) !important;
    cursor: pointer;
    font-variant-numeric: tabular-nums;
}
@media (max-width: 600px) {
    .wallet-hero-content {
        padding-top: 20px !important;
        padding-bottom: 32px !important;
    }

    .wallet-hero-header {
        min-height: 60px;
        padding-left: 58px;
        padding-right: 58px;
    }

    .wallet-hero-qr-btn {
        height: 52px !important;
        right: 6px;
        width: 52px !important;
    }

    .wallet-hero-qr-btn .v-icon {
        font-size: 32px !important;
    }

    .wallet-dynamic-key {
        max-width: 190px;
        padding-left: 10px !important;
        padding-right: 10px !important;
    }
}
.min-width-0 {
    min-width: 0;
}
.receive-qr-card {
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    box-shadow: 0 10px 28px rgba(13, 147, 165, .12);
    color: #12343B;
    max-width: 380px;
}
.receive-crypto-qr-card {
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    box-shadow: 0 10px 28px rgba(13, 147, 165, .12);
    color: #12343B;
    max-width: 390px;
}
.crypto-asset-picker .v-slide-group__content {
    align-items: stretch;
}
.crypto-asset-chip {
    border-radius: 8px !important;
    height: auto !important;
    min-height: 42px;
    padding: 0 14px !important;
}
.crypto-asset-symbol {
    color: inherit;
    display: inline-flex;
    font-size: 1rem;
    font-weight: 800;
    line-height: 1;
    min-width: 18px;
    justify-content: center;
}
.theme--light .crypto-asset-chip:not(.crypto-asset-chip-active) {
    background: #fff !important;
    border-color: rgba(13, 147, 165, .24) !important;
    color: #12343B !important;
}
.theme--dark .crypto-asset-chip:not(.crypto-asset-chip-active) {
    background: rgba(255, 255, 255, .04) !important;
    border-color: rgba(255, 255, 255, .22) !important;
    color: rgba(255, 255, 255, .88) !important;
}
.crypto-asset-chip-active {
    background: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
    color: #fff !important;
}
.theme--light .crypto-asset-chip.crypto-asset-chip-active,
.theme--light .crypto-asset-chip.v-chip--active,
.theme--dark .crypto-asset-chip.crypto-asset-chip-active,
.theme--dark .crypto-asset-chip.v-chip--active {
    background: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
    color: #fff !important;
}
.crypto-asset-chip-active .v-icon,
.crypto-asset-chip.v-chip--active .v-icon,
.crypto-asset-chip-active .v-chip__content,
.crypto-asset-chip.v-chip--active .v-chip__content {
    color: #fff !important;
}
.receive-qr-box {
    align-items: center;
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    display: inline-flex;
    justify-content: center;
    max-width: 100%;
    padding: 8px;
    position: relative;
}
.receive-crypto-qr-box {
    position: relative;
}
.valzum-qr-center-logo {
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 999px;
    box-shadow: 0 4px 14px rgba(13, 147, 165, .18);
    height: 54px;
    left: 50%;
    object-fit: contain;
    padding: 7px;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 54px;
}
.crypto-qr-center-badge {
    align-items: center;
    background: #fff;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 999px;
    box-shadow: 0 4px 14px rgba(13, 147, 165, .18);
    display: flex;
    color: var(--v-primary-base);
    font-size: 1.35rem;
    font-weight: 900;
    height: 58px;
    justify-content: center;
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 58px;
}
.crypto-qr-center-logo {
    height: 38px;
    object-fit: contain;
    width: 38px;
}
.receive-qr-box ::v-deep canvas {
    height: auto !important;
    max-width: 100%;
}
.wallet-pay-card .wallet-pay-card-body {
    padding: 16px !important;
}
.wallet-pay-card-heading {
    line-height: 1.35;
    margin-bottom: 14px;
}
.wallet-activity-card {
    border-radius: 8px;
}
.wallet-activity-item {
    min-height: 82px;
}
.wallet-activity-action {
    align-items: flex-end;
    min-width: 96px;
}
.wallet-payment-instructions {
    border-color: rgba(13, 147, 165, .22) !important;
}
.wallet-payment-instructions ::v-deep p {
    margin-bottom: 8px;
}
.wallet-payment-instructions ::v-deep img {
    height: auto;
    max-width: 100%;
}
.wallet-payment-instructions ::v-deep table {
    max-width: 100%;
    width: 100%;
}
.wallet-recharge-stepper {
    background: transparent !important;
    box-shadow: none !important;
}
.wallet-recharge-stepper ::v-deep .v-stepper__header {
    box-shadow: none;
}
.wallet-recharge-stepper ::v-deep .v-stepper__content {
    padding: 16px 0 0;
}

@media (max-width: 600px) {
    .wallet-activity-action {
        min-width: 78px;
    }
}
.wallet-fixed-dialog,
.wallet-modal-dialog {
    display: flex;
    flex-direction: column;
}
.wallet-modal-dialog {
    max-height: 90vh;
}
.wallet-fixed-header,
.wallet-fixed-footer {
    flex: 0 0 auto;
}
.wallet-fixed-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}
.wallet-scan-body {
    overflow: hidden;
}
.wallet-scan-container {
    height: 100%;
    max-width: none !important;
}
.wallet-scan-container .row {
    height: 100%;
    margin: 0;
}
.wallet-scan-col {
    flex: 0 0 100% !important;
    height: 100%;
    max-width: 100% !important;
    padding: 0 !important;
}
.wallet-scan-section {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: calc(100vh - 64px);
}
.wallet-scanner {
    background: #111;
    border-radius: 8px;
    min-height: 420px;
    overflow: hidden;
    position: relative;
}
.wallet-scanner .qrcode-stream-wrapper {
    min-height: 420px;
}
.wallet-scan-section .wallet-scanner {
    border-radius: 0;
    flex: 1 1 auto;
    height: auto;
    max-height: none;
    min-height: 0;
}
.wallet-scan-section .wallet-scanner .qrcode-stream-wrapper {
    height: 100%;
    max-height: none;
    min-height: 0;
}
.wallet-scan-section .wallet-scanner ::v-deep video {
    height: 100% !important;
    object-fit: cover;
    width: 100% !important;
}
.wallet-scan-panel {
    background: var(--v-card-base);
    box-shadow: 0 -8px 24px rgba(0, 0, 0, .18);
    flex: 0 0 auto;
    padding: 12px 16px calc(16px + env(safe-area-inset-bottom));
}
.wallet-scan-tools {
    align-items: center;
    border: 1px solid rgba(13, 147, 165, .18);
    border-radius: 8px;
    display: flex;
    gap: 8px;
    padding: 8px;
}
.wallet-scan-tools .v-input {
    flex: 1 1 auto;
    margin: 0;
}
.wallet-scan-alert {
    flex: 0 0 auto;
    margin: 12px 16px 0;
}
.scan-overlay {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 24px;
    width: 100%;
}
.scan-frame {
    aspect-ratio: 1;
    border: 3px solid var(--v-secondary-base);
    border-radius: 8px;
    box-shadow: 0 0 0 999px rgba(0, 0, 0, .28);
    max-width: 280px;
    width: 76%;
}
.scan-caption {
    background: rgba(0, 0, 0, .68);
    border-radius: 8px;
    color: #fff;
    font-weight: 700;
    margin-top: 24px;
    padding: 10px 14px;
    text-align: center;
}
.wallet-action-button .v-btn__content {
    min-width: 0;
}
.wallet-action-button span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@media (max-width: 600px) {
    .wallet-dialog-container:not(.wallet-scan-container) {
        padding: 16px 16px calc(28px + env(safe-area-inset-bottom)) !important;
    }
    .wallet-dialog-container:not(.wallet-scan-container) > .row {
        margin-left: 0;
        margin-right: 0;
    }
    .wallet-dialog-col:not(.wallet-scan-col) {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .wallet-qr-dialog {
        border-radius: 0 !important;
        height: 100%;
        max-height: 100vh;
    }
    .wallet-qr-dialog .wallet-fixed-body {
        padding: 16px !important;
    }
    .wallet-qr-dialog .wallet-fixed-footer {
        padding: 10px 16px calc(16px + env(safe-area-inset-bottom)) !important;
    }
    .wallet-fixed-header .v-toolbar__title {
        font-size: 1rem;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .wallet-fixed-header .v-chip {
        max-width: 44vw;
    }
    .wallet-fixed-body .v-card__title {
        font-size: 1rem !important;
        line-height: 1.25;
        padding: 12px 12px 4px;
        word-break: normal;
    }
    .wallet-fixed-body .v-card__subtitle,
    .wallet-fixed-body .v-card__text {
        padding-left: 12px;
        padding-right: 12px;
    }
    .wallet-pay-card .v-card__title {
        align-items: flex-start;
        line-height: 1.3 !important;
        min-height: 0;
        padding: 14px 14px 6px !important;
        white-space: normal;
    }
    .wallet-pay-card .v-card__subtitle {
        display: block;
        line-height: 1.35;
        padding: 0 14px 12px !important;
        white-space: normal;
    }
    .wallet-pay-card .v-card__text {
        padding: 0 14px 14px !important;
    }
    .wallet-pay-card .wallet-pay-card-body {
        padding: 14px !important;
    }
    .wallet-pay-card-heading {
        margin-bottom: 12px;
    }
    .wallet-fixed-body .v-list-item {
        min-height: 64px;
        padding-left: 12px;
        padding-right: 12px;
    }
    .wallet-fixed-body .v-list-item__avatar {
        margin-right: 10px;
    }
    .wallet-fixed-body .v-input {
        margin-top: 8px;
    }
    .wallet-transfer-actions {
        margin-left: -3px;
        margin-right: -3px;
    }
    .wallet-transfer-actions .col {
        padding-left: 3px;
        padding-right: 3px;
    }
    .wallet-action-button {
        padding-left: 6px !important;
        padding-right: 6px !important;
    }
    .wallet-action-button .v-icon {
        font-size: 20px !important;
        margin-right: 4px !important;
    }
    .wallet-balance-main {
        padding-left: 0;
        padding-right: 0;
    }
    .wallet-scanner,
    .wallet-scanner .qrcode-stream-wrapper {
        height: calc(100vh - 310px);
        max-height: 380px;
        min-height: 300px;
    }
    .wallet-scan-section {
        min-height: calc(100vh - 56px);
    }
    .wallet-scan-section .wallet-scanner,
    .wallet-scan-section .wallet-scanner .qrcode-stream-wrapper {
        height: auto;
        max-height: none;
        min-height: 0;
    }
    .wallet-scan-panel {
        padding: 10px 12px calc(14px + env(safe-area-inset-bottom));
    }
    .wallet-scan-tools {
        gap: 4px;
        padding: 6px 8px;
    }
    .receive-qr-card,
    .receive-crypto-qr-card {
        padding: 12px !important;
    }
    .receive-qr-box {
        max-width: 230px;
    }
    .crypto-qr-center-badge {
        height: 46px;
        width: 46px;
    }
}
</style>
